/**
 * GENERATED — do not edit.
 *
 * Runtime row validators for the tenant schema, emitted from
 * apps/backend/schema/columns.snapshot.json by apps/backend's
 * scripts/schema/generate-zod-schemas.js. Regenerate with
 * `npm run schema:zod` in apps/backend and commit the result.
 *
 * schema/tables.ts states what the server promises. These check what it
 * actually sent. Endpoints select column subsets, so validate what you
 * asked for:
 *
 *   const Shape = ProgramsSchema.pick({ id: true, key: true, label: true });
 *
 * Unknown keys pass: responses carry embedded relations and computed
 * fields that are not columns, and those are not what this guards.
 */

/* eslint-disable */
import { z } from "zod";

/** public._migration_history */
export const MigrationHistorySchema = z.object({
  applied_at: z.string().nullable(),
  applied_by: z.string().nullable(),
  checksum: z.string(),
  error_message: z.string().nullable(),
  execution_time_ms: z.number().nullable(),
  id: z.string(),
  migration_name: z.string(),
  migration_version: z.string().nullable(),
  status: z.string().nullable(),
}).passthrough();

/** public.account_notes */
export const AccountNotesSchema = z.object({
  created_at: z.string().nullable(),
  id: z.string(),
  is_starred: z.boolean().nullable(),
  membership_id: z.string().nullable(),
  metadata: z.unknown().nullable(),
  note: z.string(),
  user_id: z.string().nullable(),
}).passthrough();

/** public.action_types */
export const ActionTypesSchema = z.object({
  color: z.string().nullable(),
  created_at: z.string().nullable(),
  default_due_days: z.number().nullable(),
  description: z.string().nullable(),
  icon: z.string().nullable(),
  id: z.string(),
  is_active: z.boolean().nullable(),
  name: z.string(),
  tenant_id: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.activity_logs */
export const ActivityLogsSchema = z.object({
  activity_type: z.string(),
  created_at: z.string().nullable(),
  description: z.string().nullable(),
  entity_id: z.string().nullable(),
  entity_type: z.string(),
  id: z.string(),
  ip_address: z.string().nullable(),
  membership_id: z.string().nullable(),
  metadata: z.unknown().nullable(),
  tenant_id: z.string(),
  title: z.string(),
  user_agent: z.string().nullable(),
  user_id: z.string().nullable(),
}).passthrough();

/** public.additional_contacts */
export const AdditionalContactsSchema = z.object({
  contact_type: z.string().nullable(),
  created_at: z.string().nullable(),
  email: z.string().nullable(),
  first_name: z.string().nullable(),
  home_phone: z.string().nullable(),
  home_phone_digits: z.string().nullable(),
  id: z.string(),
  last_name: z.string().nullable(),
  membership_id: z.string().nullable(),
  mobile_phone: z.string().nullable(),
  mobile_phone_digits: z.string().nullable(),
  receive_billing_notifications: z.boolean(),
  receive_event_notifications: z.boolean(),
  receive_general_notifications: z.boolean(),
  updated_at: z.string().nullable(),
  work_phone: z.string().nullable(),
  work_phone_digits: z.string().nullable(),
}).passthrough();

/** public.ai_agent_config */
export const AiAgentConfigSchema = z.object({
  agent_name: z.string().nullable(),
  agent_persona: z.string().nullable(),
  ai_available_24_7: z.boolean().nullable(),
  ai_business_hours: z.unknown().nullable(),
  allowed_actions: z.unknown().nullable(),
  chat_enabled: z.boolean().nullable(),
  created_at: z.string().nullable(),
  greeting_chat: z.string().nullable(),
  greeting_sms: z.string().nullable(),
  greeting_voice: z.string().nullable(),
  id: z.string(),
  max_call_duration_seconds: z.number().nullable(),
  max_conversations_per_day: z.number().nullable(),
  max_sms_per_day: z.number().nullable(),
  max_tokens_per_response: z.number().nullable(),
  model_id: z.string().nullable(),
  prompt_id: z.string().nullable(),
  require_identity_verification: z.boolean().nullable(),
  restricted_actions: z.unknown().nullable(),
  sms_enabled: z.boolean().nullable(),
  temperature: z.number().nullable(),
  tenant_id: z.string(),
  transfer_phone_manual: z.string().nullable(),
  transfer_phone_mode: z.string(),
  transfer_phone_number: z.string().nullable(),
  transfer_staff_user_id: z.string().nullable(),
  twilio_phone_number: z.string().nullable(),
  updated_at: z.string().nullable(),
  voice_auth_high_tier_pin_required: z.boolean(),
  voice_auth_low_tier_soft_factor_required: z.boolean(),
  voice_enabled: z.boolean().nullable(),
  voice_language: z.string().nullable(),
  voice_name: z.string().nullable(),
  voice_provider: z.string().nullable(),
}).passthrough();

/** public.ai_chat_anon_rate */
export const AiChatAnonRateSchema = z.object({
  created_at: z.string(),
  id: z.string(),
  ip_address: z.string(),
  session_id: z.string(),
  tenant_id: z.string(),
  user_agent: z.string().nullable(),
}).passthrough();

/** public.ai_conversations */
export const AiConversationsSchema = z.object({
  actions_taken: z.unknown().nullable(),
  call_duration_seconds: z.number().nullable(),
  call_sid: z.string().nullable(),
  channel: z.string(),
  contact_email: z.string().nullable(),
  contact_name: z.string().nullable(),
  contact_phone: z.string().nullable(),
  created_at: z.string().nullable(),
  ended_at: z.string().nullable(),
  escalated_at: z.string().nullable(),
  escalated_to: z.string().nullable(),
  escalation_reason: z.string().nullable(),
  id: z.string(),
  intent_detected: z.string().nullable(),
  lead_id: z.string().nullable(),
  membership_id: z.string().nullable(),
  messages: z.unknown().nullable(),
  recording_url: z.string().nullable(),
  resolution: z.string().nullable(),
  session_id: z.string(),
  started_at: z.string().nullable(),
  status: z.string().nullable(),
  tenant_id: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.ai_employees */
export const AiEmployeesSchema = z.object({
  ai_trust_mode: z.string().nullable(),
  autonomy: z.string(),
  base_key: z.string().nullable(),
  content_limits: z.unknown(),
  created_at: z.string(),
  created_by: z.string().nullable(),
  custom_persona: z.string().nullable(),
  display_name: z.string().nullable(),
  duplicated_from: z.string().nullable(),
  enabled: z.boolean(),
  function_label: z.string(),
  id: z.string(),
  instructions_overlay: z.string().nullable(),
  kind: z.string(),
  model_id: z.string().nullable(),
  needs_review: z.boolean(),
  org_level: z.string().nullable(),
  org_placement: z.string().nullable(),
  personality_overlay: z.string().nullable(),
  template_version_id: z.string().nullable(),
  token_cap: z.number().nullable(),
  updated_at: z.string(),
}).passthrough();

/** public.ai_member_usage_daily */
export const AiMemberUsageDailySchema = z.object({
  created_at: z.string(),
  id: z.string(),
  membership_id: z.string(),
  message_count: z.number(),
  tenant_id: z.string(),
  updated_at: z.string(),
  usage_date: z.string(),
}).passthrough();

/** public.ai_staged_actions */
export const AiStagedActionsSchema = z.object({
  actor_id: z.string(),
  ai_employee_id: z.string().nullable(),
  approver_id: z.string().nullable(),
  args: z.unknown(),
  args_hash: z.string().nullable(),
  assumed: z.unknown(),
  contains: z.unknown(),
  content_hash: z.string().nullable(),
  created_at: z.string(),
  error: z.string().nullable(),
  expires_at: z.string(),
  held_by: z.string().nullable(),
  id: z.string(),
  resolved_at: z.string().nullable(),
  result: z.unknown().nullable(),
  status: z.string(),
  summary: z.string(),
  target_entity_id: z.string().nullable(),
  target_entity_type: z.string().nullable(),
  target_label: z.string().nullable(),
  task_id: z.string().nullable(),
  thread_id: z.string().nullable(),
  tool: z.string(),
}).passthrough();

/** public.ai_tool_trust_rules */
export const AiToolTrustRulesSchema = z.object({
  arg_shape: z.string(),
  created_at: z.string(),
  created_by: z.string().nullable(),
  employee_id: z.string(),
  id: z.string(),
  revoked_at: z.string().nullable(),
  revoked_by: z.string().nullable(),
  schema_hash: z.string(),
  source_pending_action_id: z.string().nullable(),
  tool_name: z.string(),
}).passthrough();

/** public.ai_usage_daily */
export const AiUsageDailySchema = z.object({
  anonymous_chat_conversations: z.number(),
  anonymous_chat_messages: z.number(),
  chat_conversations: z.number().nullable(),
  created_at: z.string().nullable(),
  escalated_count: z.number().nullable(),
  id: z.string(),
  input_tokens_total: z.number().nullable(),
  marketing_drafts: z.number(),
  marketing_extractions: z.number(),
  output_tokens_total: z.number().nullable(),
  resolved_count: z.number().nullable(),
  sms_conversations: z.number().nullable(),
  staff_chat_conversations: z.number(),
  tenant_id: z.string(),
  total_messages: z.number().nullable(),
  total_voice_minutes: z.number().nullable(),
  updated_at: z.string().nullable(),
  usage_date: z.string(),
  voice_conversations: z.number().nullable(),
}).passthrough();

/** public.analytics_events */
export const AnalyticsEventsSchema = z.object({
  created_at: z.string().nullable(),
  event_type: z.string(),
  id: z.string(),
  metadata: z.unknown().nullable(),
  page_path: z.string().nullable(),
  referrer: z.string().nullable(),
  session_id: z.string().nullable(),
  tenant_id: z.string().nullable(),
  utm_campaign: z.string().nullable(),
  utm_medium: z.string().nullable(),
  utm_source: z.string().nullable(),
}).passthrough();

/** public.athlete_deletion_log */
export const AthleteDeletionLogSchema = z.object({
  deleted_at: z.string(),
  deleted_athlete_id: z.string(),
  deleted_athlete_name: z.string().nullable(),
  deleted_athlete_snapshot: z.unknown(),
  deleted_by: z.string().nullable(),
  deleted_by_name: z.string().nullable(),
  id: z.string(),
  membership_id: z.string().nullable(),
  reason: z.string().nullable(),
  related_counts: z.unknown().nullable(),
  tenant_id: z.string().nullable(),
}).passthrough();

/** public.athlete_goals */
export const AthleteGoalsSchema = z.object({
  athlete_id: z.string(),
  completed_at: z.string().nullable(),
  created_at: z.string().nullable(),
  created_by: z.string().nullable(),
  description: z.string().nullable(),
  goal_type: z.string(),
  id: z.string(),
  progress: z.number().nullable(),
  skill_id: z.string().nullable(),
  status: z.string(),
  target_date: z.string().nullable(),
  target_proficiency: z.number().nullable(),
  tenant_id: z.string(),
  title: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.athlete_milestones */
export const AthleteMilestonesSchema = z.object({
  achieved_at: z.string().nullable(),
  athlete_id: z.string(),
  created_at: z.string().nullable(),
  description: z.string().nullable(),
  goal_id: z.string().nullable(),
  id: z.string(),
  milestone_type: z.string(),
  recorded_by: z.string().nullable(),
  skill_id: z.string().nullable(),
  tenant_id: z.string(),
  title: z.string(),
}).passthrough();

/** public.athlete_monthly_payments */
export const AthleteMonthlyPaymentsSchema = z.object({
  amount: z.number(),
  athlete_id: z.string().nullable(),
  created_at: z.string().nullable(),
  due_date: z.string(),
  id: z.string(),
  invoice_id: z.string().nullable(),
  payment_date: z.string(),
  status: z.string().nullable(),
  stripe_payment_intent_id: z.string().nullable(),
  tenant_id: z.string().nullable(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.athlete_skill_assessments */
export const AthleteSkillAssessmentsSchema = z.object({
  assessed_at: z.string().nullable(),
  assessed_by: z.string().nullable(),
  athlete_id: z.string(),
  id: z.string(),
  notes: z.string().nullable(),
  proficiency: z.number(),
  skill_id: z.string(),
  tenant_id: z.string(),
}).passthrough();

/** public.athlete_teams */
export const AthleteTeamsSchema = z.object({
  athlete_id: z.string().nullable(),
  created_at: z.string().nullable(),
  id: z.string(),
  team_id: z.string().nullable(),
}).passthrough();

/** public.athletes */
export const AthletesSchema = z.object({
  attire: z.unknown().nullable(),
  auto_deactivated_at: z.string().nullable(),
  billing_hours_override: z.number().nullable(),
  cancellation_reason: z.string().nullable(),
  cancellation_scheduled_at: z.string().nullable(),
  cancellation_scheduled_by: z.string().nullable(),
  cell_phone: z.string().nullable(),
  created_at: z.string().nullable(),
  date_of_birth: z.string().nullable(),
  first_name: z.string().nullable(),
  gender: z.string().nullable(),
  id: z.string(),
  inactivity_admin_notified_at: z.string().nullable(),
  inactivity_email_sent_at: z.string().nullable(),
  insurance_carrier: z.string().nullable(),
  insurance_phone: z.string().nullable(),
  kiosk_pin: z.string().nullable(),
  last_name: z.string().nullable(),
  medical_information: z.string().nullable(),
  medical_nothing_to_report_at: z.string().nullable(),
  medical_nothing_to_report_by: z.string().nullable(),
  medical_nothing_to_report_source: z.string().nullable(),
  medication: z.string().nullable(),
  membership_id: z.string().nullable(),
  metadata: z.unknown().nullable(),
  middle_name: z.string().nullable(),
  no_photos: z.boolean(),
  parental_consent_at: z.string().nullable(),
  parental_consent_by_user_id: z.string().nullable(),
  parental_consent_ip: z.string().nullable(),
  parental_consent_snapshot: z.string().nullable(),
  parental_consent_user_agent: z.string().nullable(),
  parental_consent_version: z.string().nullable(),
  physician_name: z.string().nullable(),
  physician_office_phone: z.string().nullable(),
  pin_hash: z.string().nullable(),
  prefered_first_name: z.string().nullable(),
  scheduled_cancellation_date: z.string().nullable(),
  signin_auth_id: z.string().nullable(),
  signin_enabled: z.boolean(),
  signin_enabled_at: z.string().nullable(),
  signin_enabled_by_user_id: z.string().nullable(),
  signin_last_login_at: z.string().nullable(),
  signin_pin_attempts: z.number(),
  signin_pin_locked_until: z.string().nullable(),
  status: z.string(),
  suffix: z.string().nullable(),
  team_level: z.string().nullable(),
  tenant_id: z.string().nullable(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.attendance_records */
export const AttendanceRecordsSchema = z.object({
  archived_at: z.string().nullable(),
  athlete_id: z.string().nullable(),
  attendance_date: z.string(),
  checked_in_at: z.string().nullable(),
  checked_in_by: z.string().nullable(),
  checked_out_at: z.string().nullable(),
  checked_out_by: z.string().nullable(),
  context_type: z.string(),
  created_at: z.string().nullable(),
  daily_notes: z.unknown().nullable(),
  event_id: z.string().nullable(),
  id: z.string(),
  is_makeup: z.boolean(),
  makeup_for_attendance_id: z.string().nullable(),
  marked_at: z.string().nullable(),
  marked_by: z.string().nullable(),
  notes: z.string().nullable(),
  program_id: z.string().nullable(),
  registration_id: z.string().nullable(),
  slot_id: z.string().nullable(),
  status: z.string(),
  tenant_id: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.attendance_session_notes */
export const AttendanceSessionNotesSchema = z.object({
  attendance_date: z.string(),
  created_at: z.string().nullable(),
  created_by: z.string().nullable(),
  id: z.string(),
  notes: z.string().nullable(),
  program_id: z.string(),
  slot_id: z.string(),
  tenant_id: z.string().nullable(),
  updated_at: z.string().nullable(),
  updated_by: z.string().nullable(),
}).passthrough();

/** public.audio_products */
export const AudioProductsSchema = z.object({
  artist: z.string().nullable(),
  audio_file_url: z.string().nullable(),
  bpm: z.number().nullable(),
  category: z.string(),
  created_at: z.string().nullable(),
  created_by: z.string().nullable(),
  description: z.string().nullable(),
  duration: z.number().nullable(),
  featured: z.boolean().nullable(),
  genre: z.string().nullable(),
  id: z.string(),
  image_url: z.string().nullable(),
  is_published: z.boolean().nullable(),
  name: z.string(),
  preview_url: z.string().nullable(),
  price: z.number(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.auth_login_events */
export const AuthLoginEventsSchema = z.object({
  attempted_email: z.string().nullable(),
  auth_id: z.string().nullable(),
  created_at: z.string(),
  failure_reason: z.string().nullable(),
  id: z.string(),
  ip_address: z.string().nullable(),
  ip_city: z.string().nullable(),
  ip_country_code: z.string().nullable(),
  ip_lat: z.number().nullable(),
  ip_lng: z.number().nullable(),
  ip_region: z.string().nullable(),
  metadata: z.unknown(),
  success: z.boolean(),
  tenant_id: z.string().nullable(),
  user_agent: z.string().nullable(),
  user_id: z.string().nullable(),
}).passthrough();

/** public.auth_rejections */
export const AuthRejectionsSchema = z.object({
  created_at: z.string(),
  detail: z.string().nullable(),
  id: z.string(),
  ip: z.string().nullable(),
  path: z.string().nullable(),
  reason: z.string(),
  token_iat: z.string().nullable(),
  token_sub: z.string().nullable(),
  user_agent: z.string().nullable(),
}).passthrough();

/** public.auto_reply_config */
export const AutoReplyConfigSchema = z.object({
  ai_auto_reply_enabled: z.boolean().nullable(),
  ai_handles_missed_calls: z.boolean().nullable(),
  ai_handles_sms: z.boolean().nullable(),
  business_hours: z.unknown().nullable(),
  business_hours_only: z.boolean().nullable(),
  created_at: z.string().nullable(),
  do_not_reply_keywords: z.unknown().nullable(),
  email_auto_reply_enabled: z.boolean().nullable(),
  email_auto_reply_html: z.string().nullable(),
  email_auto_reply_message: z.string().nullable(),
  email_auto_reply_subject: z.string().nullable(),
  id: z.string(),
  max_auto_replies_per_day: z.number().nullable(),
  missed_call_textback_delay_seconds: z.number().nullable(),
  missed_call_textback_enabled: z.boolean().nullable(),
  missed_call_textback_message: z.string().nullable(),
  sms_auto_reply_delay_seconds: z.number().nullable(),
  sms_auto_reply_enabled: z.boolean().nullable(),
  sms_auto_reply_message: z.string().nullable(),
  tenant_id: z.string(),
  timezone: z.string().nullable(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.broadcast_channel_sends */
export const BroadcastChannelSendsSchema = z.object({
  audience: z.unknown(),
  bounced_count: z.number(),
  broadcast_id: z.string(),
  channel: z.string(),
  clicked_count: z.number(),
  content: z.unknown(),
  created_at: z.string(),
  delivered_count: z.number(),
  derived_from: z.string().nullable(),
  error_message: z.string().nullable(),
  failed_count: z.number(),
  id: z.string(),
  opened_count: z.number(),
  recipient_count: z.number(),
  sent_at: z.string().nullable(),
  status: z.string(),
  success_count: z.number(),
  tenant_id: z.string().nullable(),
  updated_at: z.string(),
}).passthrough();

/** public.broadcast_recipients */
export const BroadcastRecipientsSchema = z.object({
  bounce_type: z.string().nullable(),
  bounced_at: z.string().nullable(),
  broadcast_id: z.string(),
  clicked_at: z.string().nullable(),
  created_at: z.string().nullable(),
  delivered_at: z.string().nullable(),
  email: z.string(),
  error_message: z.string().nullable(),
  id: z.string(),
  mailersend_message_id: z.string().nullable(),
  membership_id: z.string().nullable(),
  name: z.string().nullable(),
  opened_at: z.string().nullable(),
  sent_at: z.string().nullable(),
  status: z.string(),
}).passthrough();

/** public.broadcasts */
export const BroadcastsSchema = z.object({
  bounced_count: z.number().nullable(),
  clicked_count: z.number().nullable(),
  created_at: z.string().nullable(),
  delivered_count: z.number().nullable(),
  failed_count: z.number().nullable(),
  id: z.string(),
  image_url: z.string().nullable(),
  message: z.string(),
  metadata: z.unknown().nullable(),
  opened_count: z.number().nullable(),
  plain_text: z.string().nullable(),
  public_slug: z.string().nullable(),
  recipient_count: z.number().nullable(),
  scheduled_for: z.string().nullable(),
  sent_at: z.string().nullable(),
  sent_by_name: z.string().nullable(),
  sent_by_user_id: z.string().nullable(),
  show_as_news: z.boolean(),
  status: z.string(),
  subject: z.string(),
  success_count: z.number().nullable(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.call_events */
export const CallEventsSchema = z.object({
  call_session_id: z.string().nullable(),
  created_at: z.string(),
  event_key: z.string(),
  id: z.number(),
  payload: z.unknown().nullable(),
  source: z.string(),
  tenant_id: z.string().nullable(),
}).passthrough();

/** public.call_legs */
export const CallLegsSchema = z.object({
  answered_at: z.string().nullable(),
  call_session_id: z.string(),
  cancel_requested: z.boolean(),
  created_at: z.string(),
  end_reason: z.string().nullable(),
  ended_at: z.string().nullable(),
  group_id: z.string().nullable(),
  id: z.string(),
  ringing_at: z.string().nullable(),
  state: z.string(),
  step_index: z.number(),
  target: z.string().nullable(),
  target_kind: z.string(),
  tenant_id: z.string().nullable(),
  twilio_call_sid: z.string().nullable(),
  user_id: z.string().nullable(),
}).passthrough();

/** public.call_messages */
export const CallMessagesSchema = z.object({
  ai_summary: z.string().nullable(),
  call_session_id: z.string().nullable(),
  callback_number: z.string().nullable(),
  caller_number: z.string().nullable(),
  created_at: z.string(),
  delivered_at: z.string().nullable(),
  handled_at: z.string().nullable(),
  handled_by: z.string().nullable(),
  id: z.string(),
  kind: z.string(),
  lead_id: z.string().nullable(),
  membership_id: z.string().nullable(),
  processing_status: z.string(),
  recording_duration_seconds: z.number().nullable(),
  recording_sid: z.string().nullable(),
  recording_storage_path: z.string().nullable(),
  status: z.string(),
  task_id: z.string().nullable(),
  tenant_id: z.string().nullable(),
  transcription: z.string().nullable(),
  urgency: z.string().nullable(),
}).passthrough();

/** public.call_routing_settings */
export const CallRoutingSettingsSchema = z.object({
  after_hours_action: z.string(),
  after_hours_group_id: z.string().nullable(),
  after_hours_message: z.string().nullable(),
  announce_press_zero: z.boolean(),
  business_hours: z.unknown().nullable(),
  callback_enabled: z.boolean(),
  callback_offer_after_seconds: z.number(),
  closures: z.unknown(),
  delete_twilio_recordings: z.boolean(),
  enabled: z.boolean(),
  fallback_chain: z.unknown(),
  forwarding_lines: z.unknown(),
  hold_message: z.string().nullable(),
  hold_message_every_seconds: z.number(),
  hold_music_url: z.string().nullable(),
  id: z.string(),
  max_wait_seconds: z.number(),
  no_answer_action: z.string(),
  notify_email: z.boolean(),
  notify_user_ids: z.unknown(),
  task_assignee_user_id: z.string().nullable(),
  tenant_id: z.string().nullable(),
  timezone: z.string().nullable(),
  transfer_message: z.string().nullable(),
  updated_at: z.string(),
  updated_by: z.string().nullable(),
  voicemail_max_seconds: z.number(),
  voicemail_prompt: z.string().nullable(),
}).passthrough();

/** public.call_sessions */
export const CallSessionsSchema = z.object({
  ai_conversation_id: z.string().nullable(),
  ai_session_id: z.string().nullable(),
  answered_at: z.string().nullable(),
  answered_by_user_id: z.string().nullable(),
  answered_leg_id: z.string().nullable(),
  caller_name_cnam: z.string().nullable(),
  caller_number: z.string().nullable(),
  caller_number_source: z.string().nullable(),
  conference_sid: z.string().nullable(),
  created_at: z.string(),
  current_step_index: z.number().nullable(),
  duration_seconds: z.number().nullable(),
  ended_at: z.string().nullable(),
  escalation_reason: z.string().nullable(),
  escalation_source: z.string().nullable(),
  escalation_summary: z.string().nullable(),
  escalation_urgency: z.string().nullable(),
  forwarded_from: z.string().nullable(),
  from_raw: z.string().nullable(),
  hold_started_at: z.string().nullable(),
  id: z.string(),
  lead_id: z.string().nullable(),
  membership_id: z.string().nullable(),
  office_open: z.boolean().nullable(),
  outcome: z.string().nullable(),
  ring_plan: z.unknown().nullable(),
  state: z.string(),
  state_version: z.number(),
  tenant_id: z.string().nullable(),
  to_number: z.string().nullable(),
  twilio_call_sid: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.camp_daily_updates */
export const CampDailyUpdatesSchema = z.object({
  camp_id: z.string(),
  content: z.string(),
  created_at: z.string().nullable(),
  date: z.string(),
  id: z.string(),
  photos: z.unknown().nullable(),
  sent_at: z.string().nullable(),
  sent_by: z.string().nullable(),
  tenant_id: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.camp_email_log */
export const CampEmailLogSchema = z.object({
  camp_id: z.string().nullable(),
  email_type: z.string(),
  error_message: z.string().nullable(),
  id: z.string(),
  recipient_email: z.string(),
  registration_id: z.string().nullable(),
  sent_at: z.string().nullable(),
  status: z.string().nullable(),
  subject: z.string(),
  tenant_id: z.string(),
}).passthrough();

/** public.camp_photos */
export const CampPhotosSchema = z.object({
  camp_id: z.string(),
  caption: z.string().nullable(),
  created_at: z.string().nullable(),
  date_taken: z.string().nullable(),
  id: z.string(),
  is_featured: z.boolean().nullable(),
  photo_url: z.string(),
  sort_order: z.number().nullable(),
  tenant_id: z.string(),
  uploaded_by: z.string().nullable(),
}).passthrough();

/** public.camp_staff */
export const CampStaffSchema = z.object({
  assigned_dates: z.unknown().nullable(),
  camp_id: z.string(),
  created_at: z.string().nullable(),
  id: z.string(),
  notes: z.string().nullable(),
  role: z.string().nullable(),
  staff_id: z.string(),
  tenant_id: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.camp_templates */
export const CampTemplatesSchema = z.object({
  category: z.string().nullable(),
  created_at: z.string().nullable(),
  created_by: z.string().nullable(),
  description: z.string().nullable(),
  id: z.string(),
  is_public: z.boolean().nullable(),
  name: z.string(),
  template_data: z.unknown(),
  tenant_id: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.campaign_touches */
export const CampaignTouchesSchema = z.object({
  body: z.string().nullable(),
  broadcast_id: z.string().nullable(),
  campaign_id: z.string(),
  channel: z.string(),
  created_at: z.string(),
  id: z.string(),
  metadata: z.unknown(),
  offset_days: z.number(),
  position: z.number(),
  scheduled_for: z.string().nullable(),
  sent_at: z.string().nullable(),
  status: z.string(),
  subject: z.string().nullable(),
  updated_at: z.string(),
}).passthrough();

/** public.campaigns */
export const CampaignsSchema = z.object({
  audience_filter: z.unknown().nullable(),
  created_at: z.string().nullable(),
  end_date: z.string().nullable(),
  id: z.string(),
  metadata: z.unknown().nullable(),
  name: z.string(),
  start_date: z.string().nullable(),
  status: z.string().nullable(),
  tenant_id: z.string().nullable(),
  type: z.string().nullable(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.camps */
export const CampsSchema = z.object({
  age_max: z.number().nullable(),
  age_min: z.number().nullable(),
  camp_type: z.string().nullable(),
  cancellation_policy: z.string().nullable(),
  cover_image_url: z.string().nullable(),
  created_at: z.string().nullable(),
  created_by: z.string().nullable(),
  current_registrations: z.number().nullable(),
  dates: z.unknown().nullable(),
  description: z.string().nullable(),
  email_notifications: z.unknown().nullable(),
  id: z.string(),
  is_template: z.boolean().nullable(),
  location: z.string().nullable(),
  max_registrations: z.number().nullable(),
  members_only: z.boolean().nullable(),
  name: z.string(),
  pricing_options: z.unknown().nullable(),
  registration_deadline: z.string().nullable(),
  required_waivers: z.unknown().nullable(),
  sessions: z.unknown().nullable(),
  skill_level: z.string().nullable(),
  staff_ratio: z.string().nullable(),
  status: z.string().nullable(),
  supply_list: z.unknown().nullable(),
  template_id: z.string().nullable(),
  tenant_id: z.string(),
  updated_at: z.string().nullable(),
  visibility: z.string().nullable(),
  waitlist_enabled: z.boolean().nullable(),
  what_to_bring: z.string().nullable(),
}).passthrough();

/** public.chart_of_accounts */
export const ChartOfAccountsSchema = z.object({
  account_group: z.string(),
  account_type: z.string().nullable(),
  code: z.string().nullable(),
  created_at: z.string(),
  id: z.string(),
  is_active: z.boolean(),
  name: z.string(),
  parent_account_id: z.string().nullable(),
  sort_order: z.number().nullable(),
  updated_at: z.string(),
}).passthrough();

/** public.clinic_daily_updates */
export const ClinicDailyUpdatesSchema = z.object({
  clinic_id: z.string(),
  content: z.string(),
  created_at: z.string().nullable(),
  date: z.string(),
  id: z.string(),
  photos: z.unknown().nullable(),
  sent_at: z.string().nullable(),
  sent_by: z.string().nullable(),
  tenant_id: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.clinic_email_log */
export const ClinicEmailLogSchema = z.object({
  clinic_id: z.string().nullable(),
  email_type: z.string(),
  error_message: z.string().nullable(),
  id: z.string(),
  recipient_email: z.string(),
  registration_id: z.string().nullable(),
  sent_at: z.string().nullable(),
  status: z.string().nullable(),
  subject: z.string(),
  tenant_id: z.string(),
}).passthrough();

/** public.clinic_photos */
export const ClinicPhotosSchema = z.object({
  caption: z.string().nullable(),
  clinic_id: z.string(),
  created_at: z.string().nullable(),
  date_taken: z.string().nullable(),
  id: z.string(),
  is_featured: z.boolean().nullable(),
  photo_url: z.string(),
  sort_order: z.number().nullable(),
  tenant_id: z.string(),
  uploaded_by: z.string().nullable(),
}).passthrough();

/** public.clinic_staff */
export const ClinicStaffSchema = z.object({
  assigned_dates: z.unknown().nullable(),
  clinic_id: z.string(),
  created_at: z.string().nullable(),
  id: z.string(),
  notes: z.string().nullable(),
  role: z.string().nullable(),
  staff_id: z.string(),
  tenant_id: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.clinic_templates */
export const ClinicTemplatesSchema = z.object({
  category: z.string().nullable(),
  created_at: z.string().nullable(),
  created_by: z.string().nullable(),
  description: z.string().nullable(),
  id: z.string(),
  is_public: z.boolean().nullable(),
  name: z.string(),
  template_data: z.unknown(),
  tenant_id: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.clinics */
export const ClinicsSchema = z.object({
  age_max: z.number().nullable(),
  age_min: z.number().nullable(),
  cancellation_policy: z.string().nullable(),
  clinic_type: z.string().nullable(),
  cover_image_url: z.string().nullable(),
  created_at: z.string().nullable(),
  created_by: z.string().nullable(),
  current_registrations: z.number().nullable(),
  dates: z.unknown().nullable(),
  description: z.string().nullable(),
  email_notifications: z.unknown().nullable(),
  id: z.string(),
  is_template: z.boolean().nullable(),
  location: z.string().nullable(),
  max_registrations: z.number().nullable(),
  members_only: z.boolean().nullable(),
  name: z.string(),
  pricing_options: z.unknown().nullable(),
  registration_deadline: z.string().nullable(),
  required_waivers: z.unknown().nullable(),
  sessions: z.unknown().nullable(),
  skill_level: z.string().nullable(),
  staff_ratio: z.string().nullable(),
  status: z.string().nullable(),
  supply_list: z.unknown().nullable(),
  template_id: z.string().nullable(),
  tenant_id: z.string(),
  updated_at: z.string().nullable(),
  visibility: z.string().nullable(),
  waitlist_enabled: z.boolean().nullable(),
  what_to_bring: z.string().nullable(),
}).passthrough();

/** public.commissions */
export const CommissionsSchema = z.object({
  commission_amount: z.number(),
  commission_rate: z.number(),
  created_at: z.string().nullable(),
  gp_order_id: z.string().nullable(),
  gp_product_id: z.string().nullable(),
  gp_product_type: z.string().nullable(),
  id: z.string(),
  metadata: z.unknown().nullable(),
  order_id: z.string(),
  order_item_id: z.string().nullable(),
  paid_at: z.string().nullable(),
  payment_confirmed_at: z.string().nullable(),
  sale_amount: z.number(),
  settled_at: z.string().nullable(),
  settlement_id: z.string().nullable(),
  settlement_month: z.string().nullable(),
  status: z.string().nullable(),
}).passthrough();

/** public.communication_templates */
export const CommunicationTemplatesSchema = z.object({
  blocks: z.unknown().nullable(),
  body: z.string(),
  body_html: z.string().nullable(),
  category: z.string().nullable(),
  channels: z.unknown().nullable(),
  created_at: z.string().nullable(),
  created_by: z.string().nullable(),
  description: z.string().nullable(),
  id: z.string(),
  is_active: z.boolean().nullable(),
  last_used_at: z.string().nullable(),
  name: z.string(),
  subject: z.string().nullable(),
  tenant_id: z.string(),
  updated_at: z.string().nullable(),
  usage_count: z.number().nullable(),
  variables: z.unknown().nullable(),
}).passthrough();

/** public.competition_awards */
export const CompetitionAwardsSchema = z.object({
  apparatus_or_event_key: z.string().nullable(),
  award_type: z.string(),
  competition_id: z.string(),
  division_id: z.string().nullable(),
  entry_id: z.string().nullable(),
  id: z.string(),
  metadata_json: z.unknown(),
  place: z.number(),
  recorded_at: z.string(),
  team_label: z.string().nullable(),
  tenant_id: z.string(),
  total_score: z.number().nullable(),
}).passthrough();

/** public.competition_check_ins */
export const CompetitionCheckInsSchema = z.object({
  at: z.string(),
  by_user_id: z.string().nullable(),
  competition_id: z.string(),
  created_at: z.string(),
  entry_id: z.string(),
  id: z.string(),
  notes: z.string().nullable(),
  status: z.string(),
  tenant_id: z.string(),
}).passthrough();

/** public.competition_divisions */
export const CompetitionDivisionsSchema = z.object({
  axes_json: z.unknown(),
  competition_id: z.string(),
  created_at: z.string(),
  id: z.string(),
  name: z.string(),
  sort_order: z.number(),
  tenant_id: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.competition_entries */
export const CompetitionEntriesSchema = z.object({
  athlete_id: z.string().nullable(),
  bib_number: z.string().nullable(),
  competition_id: z.string(),
  created_at: z.string(),
  division_id: z.string().nullable(),
  gym_or_club_label: z.string().nullable(),
  id: z.string(),
  metadata_json: z.unknown(),
  seed: z.number().nullable(),
  status: z.string(),
  team_id: z.string().nullable(),
  tenant_id: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.competition_floors */
export const CompetitionFloorsSchema = z.object({
  competition_id: z.string(),
  created_at: z.string(),
  id: z.string(),
  label: z.string(),
  sort_order: z.number(),
  tenant_id: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.competition_imports */
export const CompetitionImportsSchema = z.object({
  adapter_key: z.string(),
  applied_at: z.string().nullable(),
  applied_by: z.string().nullable(),
  competition_id: z.string(),
  created_at: z.string(),
  error_text: z.string().nullable(),
  id: z.string(),
  mapping_json: z.unknown(),
  source_file_name: z.string().nullable(),
  source_file_url: z.string().nullable(),
  status: z.string(),
  tenant_id: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.competition_matches */
export const CompetitionMatchesSchema = z.object({
  apparatus_or_event_key: z.string().nullable(),
  bracket_round: z.number().nullable(),
  competition_id: z.string(),
  created_at: z.string(),
  division_id: z.string().nullable(),
  floor_id: z.string().nullable(),
  id: z.string(),
  metadata_json: z.unknown(),
  parent_match_id: z.string().nullable(),
  phase_id: z.string().nullable(),
  position_in_bracket: z.number().nullable(),
  scheduled_at: z.string().nullable(),
  side_a_entry_id: z.string().nullable(),
  side_b_entry_id: z.string().nullable(),
  status: z.string(),
  tenant_id: z.string(),
  updated_at: z.string(),
  winner_entry_id: z.string().nullable(),
}).passthrough();

/** public.competition_messages */
export const CompetitionMessagesSchema = z.object({
  body: z.string(),
  competition_id: z.string(),
  from_user_id: z.string(),
  id: z.string(),
  metadata_json: z.unknown(),
  scope_json: z.unknown(),
  sent_at: z.string(),
  tenant_id: z.string(),
}).passthrough();

/** public.competition_officials */
export const CompetitionOfficialsSchema = z.object({
  competition_id: z.string(),
  created_at: z.string(),
  display_name: z.string(),
  id: z.string(),
  role: z.string(),
  scope_json: z.unknown(),
  status: z.string(),
  tenant_id: z.string(),
  updated_at: z.string(),
  user_id: z.string().nullable(),
}).passthrough();

/** public.competition_phases */
export const CompetitionPhasesSchema = z.object({
  competition_id: z.string(),
  created_at: z.string(),
  format_key: z.string(),
  id: z.string(),
  key: z.string(),
  label: z.string(),
  metadata_json: z.unknown(),
  scheduled_end: z.string().nullable(),
  scheduled_start: z.string().nullable(),
  sort_order: z.number(),
  status: z.string(),
  tenant_id: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.competition_scores */
export const CompetitionScoresSchema = z.object({
  apparatus_or_event_key: z.string().nullable(),
  competition_id: z.string(),
  created_at: z.string(),
  entry_id: z.string(),
  id: z.string(),
  judge_official_id: z.string().nullable(),
  match_id: z.string().nullable(),
  metadata_json: z.unknown(),
  recorded_at: z.string(),
  recorded_by: z.string().nullable(),
  score_json: z.unknown(),
  status: z.string(),
  tenant_id: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.competition_share_links */
export const CompetitionShareLinksSchema = z.object({
  competition_id: z.string(),
  created_at: z.string(),
  created_by: z.string().nullable(),
  expires_at: z.string().nullable(),
  id: z.string(),
  last_accessed_at: z.string().nullable(),
  role: z.string(),
  scope_json: z.unknown(),
  tenant_id: z.string(),
  token: z.string(),
}).passthrough();

/** public.competition_standings */
export const CompetitionStandingsSchema = z.object({
  apparatus_or_event_key: z.string().nullable(),
  breakdown_json: z.unknown(),
  competition_id: z.string(),
  computed_at: z.string(),
  division_id: z.string().nullable(),
  entry_id: z.string(),
  id: z.string(),
  rank: z.number(),
  tenant_id: z.string(),
  total_score: z.number().nullable(),
}).passthrough();

/** public.competitions */
export const CompetitionsSchema = z.object({
  created_at: z.string(),
  event_id: z.string(),
  format_key: z.string(),
  id: z.string(),
  scoring_ruleset_key: z.string(),
  settings_json: z.unknown(),
  sport_id: z.string(),
  sport_key: z.string(),
  status: z.string(),
  tenant_id: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.contact_list_members */
export const ContactListMembersSchema = z.object({
  added_at: z.string().nullable(),
  added_by: z.string().nullable(),
  contact_id: z.string(),
  contact_type: z.string(),
  id: z.string(),
  list_id: z.string(),
}).passthrough();

/** public.contact_lists */
export const ContactListsSchema = z.object({
  color: z.string().nullable(),
  created_at: z.string().nullable(),
  created_by: z.string().nullable(),
  description: z.string().nullable(),
  filter_criteria: z.unknown().nullable(),
  id: z.string(),
  is_dynamic: z.boolean().nullable(),
  name: z.string(),
  tenant_id: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.dashboard_widgets */
export const DashboardWidgetsSchema = z.object({
  component_key: z.string(),
  created_at: z.string(),
  default_config: z.unknown(),
  description: z.string().nullable(),
  id: z.string(),
  name: z.string(),
  required_permission: z.string().nullable(),
  updated_at: z.string(),
}).passthrough();

/** public.design_draft_ops */
export const DesignDraftOpsSchema = z.object({
  action: z.string(),
  after_value: z.unknown().nullable(),
  args: z.unknown(),
  before_value: z.unknown().nullable(),
  created_at: z.string(),
  draft_id: z.string(),
  id: z.string(),
  minted_ids: z.unknown(),
  op_index: z.number(),
  target_element_id: z.string().nullable(),
}).passthrough();

/** public.design_drafts */
export const DesignDraftsSchema = z.object({
  base_document: z.unknown(),
  created_at: z.string(),
  created_by: z.string().nullable(),
  cursor: z.number(),
  design_id: z.string(),
  id: z.string(),
  preview_token: z.string(),
  status: z.string(),
  tenant_id: z.string(),
  updated_at: z.string(),
  working_document: z.unknown(),
}).passthrough();

/** public.design_snapshots */
export const DesignSnapshotsSchema = z.object({
  created_at: z.string(),
  created_by: z.string().nullable(),
  design_id: z.string(),
  document: z.unknown(),
  id: z.string(),
  label: z.string().nullable(),
  tenant_id: z.string(),
}).passthrough();

/** public.designs */
export const DesignsSchema = z.object({
  archived_at: z.string().nullable(),
  created_at: z.string(),
  created_by: z.string().nullable(),
  document: z.unknown(),
  height: z.number(),
  id: z.string(),
  is_template: z.boolean(),
  name: z.string(),
  preset_key: z.string().nullable(),
  share_enabled: z.boolean(),
  share_token: z.string().nullable(),
  tags: z.unknown(),
  tenant_id: z.string(),
  thumbnail_url: z.string().nullable(),
  updated_at: z.string(),
  updated_by: z.string().nullable(),
  width: z.number(),
}).passthrough();

/** public.discount_code_redemptions */
export const DiscountCodeRedemptionsSchema = z.object({
  discount_code_id: z.string(),
  id: z.string(),
  member_email: z.string().nullable(),
  membership_id: z.string().nullable(),
  redeemed_at: z.string(),
  source_record_id: z.string().nullable(),
  source_table: z.string().nullable(),
}).passthrough();

/** public.discount_codes */
export const DiscountCodesSchema = z.object({
  active: z.boolean().nullable(),
  applicable_to: z.unknown().nullable(),
  code: z.string(),
  created_at: z.string().nullable(),
  description: z.string().nullable(),
  id: z.string(),
  max_uses: z.number().nullable(),
  max_uses_per_member: z.number().nullable(),
  tenant_id: z.string().nullable(),
  type: z.string(),
  updated_at: z.string().nullable(),
  used_count: z.number().nullable(),
  valid_from: z.string().nullable(),
  valid_until: z.string().nullable(),
  value: z.number(),
}).passthrough();

/** public.discounts */
export const DiscountsSchema = z.object({
  code: z.string().nullable(),
  created_at: z.string().nullable(),
  description: z.string().nullable(),
  end_date: z.string().nullable(),
  id: z.string(),
  is_active: z.boolean().nullable(),
  start_date: z.string().nullable(),
  tenant_id: z.string().nullable(),
  type: z.string().nullable(),
  updated_at: z.string().nullable(),
  value: z.number().nullable(),
}).passthrough();

/** public.document_acknowledgments */
export const DocumentAcknowledgmentsSchema = z.object({
  acknowledged_at: z.string().nullable(),
  created_at: z.string().nullable(),
  document_id: z.string(),
  id: z.string(),
  ip_address: z.string().nullable(),
  signature: z.string().nullable(),
  tenant_id: z.string(),
  user_id: z.string(),
}).passthrough();

/** public.email_header_footer_templates */
export const EmailHeaderFooterTemplatesSchema = z.object({
  created_at: z.string().nullable(),
  html_content: z.string(),
  id: z.string(),
  is_default: z.boolean().nullable(),
  template_type: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.email_suppressions */
export const EmailSuppressionsSchema = z.object({
  added_by_user_id: z.string().nullable(),
  bounce_count: z.number(),
  email: z.string(),
  first_seen_at: z.string(),
  id: z.string(),
  last_error_message: z.string().nullable(),
  last_seen_at: z.string(),
  notes: z.string().nullable(),
  reason: z.string(),
  removed_at: z.string().nullable(),
  removed_by_user_id: z.string().nullable(),
  removed_reason: z.string().nullable(),
  source: z.string().nullable(),
  tenant_id: z.string(),
}).passthrough();

/** public.email_templates */
export const EmailTemplatesSchema = z.object({
  category: z.string().nullable(),
  created_at: z.string().nullable(),
  created_by: z.string().nullable(),
  html_content: z.string(),
  id: z.string(),
  is_default: z.boolean().nullable(),
  notification_key: z.string(),
  role_id: z.string().nullable(),
  subject: z.string(),
  tenant_id: z.string().nullable(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.email_verification_cache */
export const EmailVerificationCacheSchema = z.object({
  checked_at: z.string(),
  email: z.string(),
  reason: z.string().nullable(),
  status: z.string(),
}).passthrough();

/** public.email_verification_jobs */
export const EmailVerificationJobsSchema = z.object({
  cached_hits: z.number(),
  completed_at: z.string().nullable(),
  created_at: z.string(),
  error_message: z.string().nullable(),
  id: z.string(),
  invalid_count: z.number(),
  mailersend_list_id: z.string().nullable(),
  requested_by: z.string().nullable(),
  requested_by_name: z.string().nullable(),
  risky_count: z.number(),
  scope: z.string().nullable(),
  status: z.string(),
  submitted_count: z.number(),
  total_emails: z.number(),
  updated_at: z.string(),
  valid_count: z.number(),
}).passthrough();

/** public.employee_profiles */
export const EmployeeProfilesSchema = z.object({
  created_at: z.string().nullable(),
  department: z.string().nullable(),
  emergency_contact_name: z.string().nullable(),
  emergency_contact_phone: z.string().nullable(),
  employment_type: z.string().nullable(),
  hire_date: z.string().nullable(),
  id: z.string(),
  notes: z.string().nullable(),
  pay_rate: z.number().nullable(),
  pay_type: z.string().nullable(),
  position: z.string().nullable(),
  status: z.string().nullable(),
  tenant_id: z.string(),
  termination_date: z.string().nullable(),
  updated_at: z.string().nullable(),
  user_id: z.string(),
}).passthrough();

/** public.equipment */
export const EquipmentSchema = z.object({
  barcode: z.string().nullable(),
  category: z.string(),
  created_at: z.string().nullable(),
  description: z.string().nullable(),
  featured: z.boolean().nullable(),
  has_variants: z.boolean().nullable(),
  id: z.string(),
  image: z.string().nullable(),
  image_gallery: z.unknown().nullable(),
  inventory: z.number(),
  low_stock_threshold: z.number().nullable(),
  name: z.string(),
  price: z.number(),
  sku: z.string().nullable(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.escalation_group_members */
export const EscalationGroupMembersSchema = z.object({
  active: z.boolean(),
  created_at: z.string(),
  external_e164: z.string().nullable(),
  external_label: z.string().nullable(),
  group_id: z.string(),
  id: z.string(),
  member_kind: z.string(),
  position: z.number(),
  require_keypress: z.boolean(),
  ring_app: z.boolean(),
  ring_phone: z.boolean(),
  ring_web: z.boolean(),
  tenant_id: z.string().nullable(),
  user_id: z.string().nullable(),
}).passthrough();

/** public.escalation_groups */
export const EscalationGroupsSchema = z.object({
  active: z.boolean(),
  created_at: z.string(),
  created_by: z.string().nullable(),
  id: z.string(),
  intents: z.unknown(),
  member_timeout_seconds: z.number(),
  name: z.string(),
  ring_strategy: z.string(),
  ring_timeout_seconds: z.number(),
  tenant_id: z.string().nullable(),
  updated_at: z.string(),
}).passthrough();

/** public.event_addons */
export const EventAddonsSchema = z.object({
  amount: z.number(),
  created_at: z.string(),
  description: z.string().nullable(),
  event_id: z.string(),
  id: z.string(),
  label: z.string(),
  sort_order: z.number(),
  status: z.string(),
  tenant_id: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.event_announcements */
export const EventAnnouncementsSchema = z.object({
  content: z.string(),
  created_at: z.string().nullable(),
  event_id: z.string(),
  id: z.string(),
  recipient_count: z.number().nullable(),
  send_email: z.boolean().nullable(),
  send_notification: z.boolean().nullable(),
  sent_at: z.string().nullable(),
  sent_by: z.string().nullable(),
  tenant_id: z.string(),
  title: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.event_attachments */
export const EventAttachmentsSchema = z.object({
  created_at: z.string().nullable(),
  description: z.string().nullable(),
  event_id: z.string(),
  file_name: z.string(),
  file_size: z.number().nullable(),
  file_type: z.string(),
  id: z.string(),
  is_cover_image: z.boolean().nullable(),
  storage_path: z.string(),
  tenant_id: z.string(),
  thumbnail_url: z.string().nullable(),
  updated_at: z.string().nullable(),
  uploaded_by: z.string().nullable(),
  url: z.string(),
}).passthrough();

/** public.event_attendance_log */
export const EventAttendanceLogSchema = z.object({
  action: z.string(),
  device_info: z.unknown().nullable(),
  event_id: z.string(),
  id: z.string(),
  notes: z.string().nullable(),
  performed_at: z.string().nullable(),
  performed_by: z.string().nullable(),
  registration_id: z.string(),
  tenant_id: z.string(),
}).passthrough();

/** public.event_broadcasts */
export const EventBroadcastsSchema = z.object({
  audience_filter_json: z.unknown(),
  body_html: z.string(),
  event_id: z.string(),
  id: z.string(),
  recipient_count: z.number(),
  sent_at: z.string(),
  sent_by: z.string().nullable(),
  subject: z.string(),
  tenant_id: z.string(),
}).passthrough();

/** public.event_categories */
export const EventCategoriesSchema = z.object({
  color: z.string().nullable(),
  created_at: z.string().nullable(),
  description: z.string().nullable(),
  icon: z.string().nullable(),
  id: z.string(),
  is_active: z.boolean().nullable(),
  name: z.string(),
  sort_order: z.number().nullable(),
  tenant_id: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.event_co_hosts */
export const EventCoHostsSchema = z.object({
  added_at: z.string(),
  added_by: z.string().nullable(),
  event_id: z.string(),
  id: z.string(),
  scope: z.string(),
  tenant_id: z.string(),
  user_id: z.string(),
}).passthrough();

/** public.event_feedback */
export const EventFeedbackSchema = z.object({
  admin_responded_at: z.string().nullable(),
  admin_responded_by: z.string().nullable(),
  admin_response: z.string().nullable(),
  created_at: z.string().nullable(),
  event_id: z.string(),
  feedback_text: z.string().nullable(),
  id: z.string(),
  is_public: z.boolean().nullable(),
  membership_id: z.string(),
  organization_rating: z.number().nullable(),
  overall_rating: z.number().nullable(),
  registration_id: z.string().nullable(),
  status: z.string().nullable(),
  tenant_id: z.string(),
  updated_at: z.string().nullable(),
  value_rating: z.number().nullable(),
  venue_rating: z.number().nullable(),
  would_recommend: z.boolean().nullable(),
}).passthrough();

/** public.event_instructors */
export const EventInstructorsSchema = z.object({
  bio: z.string().nullable(),
  created_at: z.string(),
  display_name: z.string(),
  event_id: z.string(),
  id: z.string(),
  photo_url: z.string().nullable(),
  role: z.string().nullable(),
  sort_order: z.number(),
  status: z.string(),
  tenant_id: z.string(),
  updated_at: z.string(),
  user_id: z.string().nullable(),
}).passthrough();

/** public.event_invitations */
export const EventInvitationsSchema = z.object({
  accepted_at: z.string().nullable(),
  created_at: z.string().nullable(),
  created_by: z.string().nullable(),
  email: z.string(),
  event_id: z.string(),
  first_name: z.string().nullable(),
  id: z.string(),
  invitation_token: z.string().nullable(),
  last_name: z.string().nullable(),
  message: z.string().nullable(),
  sent_at: z.string().nullable(),
  status: z.string().nullable(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.event_listing_reminders */
export const EventListingRemindersSchema = z.object({
  claimed_at: z.string(),
  error_message: z.string().nullable(),
  event_id: z.string(),
  hours_before: z.number().nullable(),
  id: z.string(),
  kind: z.string(),
  registration_id: z.string(),
  send_key: z.string(),
  sent_at: z.string().nullable(),
  session_date: z.string().nullable(),
  status: z.string(),
  tenant_id: z.string(),
}).passthrough();

/** public.event_merch_offerings */
export const EventMerchOfferingsSchema = z.object({
  cached_image_url: z.string().nullable(),
  cached_price_cents: z.number().nullable(),
  created_at: z.string(),
  description: z.string().nullable(),
  display_name: z.string(),
  event_id: z.string(),
  gp_product_id: z.string(),
  id: z.string(),
  per_event_quantity_limit: z.number().nullable(),
  required: z.boolean(),
  sort_order: z.number(),
  status: z.string(),
  tenant_id: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.event_merch_orders */
export const EventMerchOrdersSchema = z.object({
  created_at: z.string(),
  event_id: z.string(),
  failure_reason: z.string().nullable(),
  gp_order_id: z.string().nullable(),
  gp_order_status: z.string(),
  gp_product_id: z.string(),
  id: z.string(),
  metadata: z.unknown(),
  offering_id: z.string().nullable(),
  quantity: z.number(),
  registration_id: z.string().nullable(),
  tenant_id: z.string(),
  total_cents: z.number(),
  unit_price_cents: z.number(),
  updated_at: z.string(),
  user_id: z.string().nullable(),
}).passthrough();

/** public.event_payment_logs */
export const EventPaymentLogsSchema = z.object({
  action_type: z.string(),
  created_at: z.string().nullable(),
  details: z.unknown().nullable(),
  event_id: z.string().nullable(),
  id: z.string(),
  recipient_email: z.string().nullable(),
  recipient_name: z.string().nullable(),
  registration_id: z.string().nullable(),
  tenant_id: z.string().nullable(),
}).passthrough();

/** public.event_photos */
export const EventPhotosSchema = z.object({
  caption: z.string().nullable(),
  created_at: z.string(),
  event_id: z.string(),
  id: z.string(),
  sort_order: z.number(),
  tenant_id: z.string(),
  thumbnail_url: z.string().nullable(),
  uploaded_by: z.string().nullable(),
  url: z.string(),
}).passthrough();

/** public.event_registration_questions */
export const EventRegistrationQuestionsSchema = z.object({
  applies_to: z.string(),
  created_at: z.string(),
  description: z.string().nullable(),
  event_id: z.string(),
  id: z.string(),
  options_json: z.unknown(),
  prompt: z.string(),
  question_type: z.string(),
  required: z.boolean(),
  sort_order: z.number(),
  status: z.string(),
  tenant_id: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.event_registration_responses */
export const EventRegistrationResponsesSchema = z.object({
  answer_json: z.unknown(),
  athlete_id: z.string().nullable(),
  created_at: z.string(),
  event_id: z.string(),
  id: z.string(),
  question_id: z.string(),
  registration_id: z.string(),
  tenant_id: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.event_registrations */
export const EventRegistrationsSchema = z.object({
  addons: z.unknown().nullable(),
  addons_amount: z.number(),
  allergies: z.string().nullable(),
  amount_paid: z.number().nullable(),
  athlete_id: z.string().nullable(),
  auto_cancelled_at: z.string().nullable(),
  balance_amount_paid: z.number().nullable(),
  batch_id: z.string().nullable(),
  cancellation_reason: z.string().nullable(),
  cancelled_at: z.string().nullable(),
  check_in_notes: z.string().nullable(),
  checked_in_at: z.string().nullable(),
  checked_in_by: z.string().nullable(),
  checked_out_at: z.string().nullable(),
  contact_email: z.string().nullable(),
  contact_phone: z.string().nullable(),
  created_at: z.string().nullable(),
  date_of_birth: z.string().nullable(),
  dietary_restrictions: z.string().nullable(),
  emergency_contact_name: z.string().nullable(),
  emergency_contact_phone: z.string().nullable(),
  emergency_contact_relationship: z.string().nullable(),
  event_id: z.string(),
  feedback_submitted: z.boolean().nullable(),
  first_name: z.string().nullable(),
  follow_up_sent_at: z.string().nullable(),
  gender: z.string().nullable(),
  id: z.string(),
  invoice_id: z.string().nullable(),
  last_name: z.string().nullable(),
  medical_info: z.string().nullable(),
  medical_notes: z.string().nullable(),
  medications: z.string().nullable(),
  membership_id: z.string(),
  notes: z.string().nullable(),
  paid_at: z.string().nullable(),
  payment_deadline: z.string().nullable(),
  payment_reminder_sent_at: z.string().nullable(),
  payment_status: z.string().nullable(),
  pickup_authorized: z.unknown().nullable(),
  pricing_option: z.unknown().nullable(),
  promoted_at: z.string().nullable(),
  promotion_payment_required: z.boolean().nullable(),
  qr_code: z.string().nullable(),
  qr_generated_at: z.string().nullable(),
  refund_amount: z.number().nullable(),
  refund_id: z.string().nullable(),
  refund_status: z.string().nullable(),
  refund_stripe_id: z.string().nullable(),
  refunded_at: z.string().nullable(),
  registered_at: z.string().nullable(),
  registration_data: z.unknown().nullable(),
  selected_date: z.unknown().nullable(),
  selected_dates: z.unknown().nullable(),
  session_id: z.string().nullable(),
  session_preference: z.string().nullable(),
  status: z.string().nullable(),
  stripe_payment_intent_id: z.string().nullable(),
  tenant_id: z.string(),
  ticket_type: z.string(),
  transaction_id: z.string().nullable(),
  updated_at: z.string().nullable(),
  waitlist_position: z.number().nullable(),
  waitlisted_at: z.string().nullable(),
  waiver_signatures: z.unknown().nullable(),
}).passthrough();

/** public.event_reminder_logs */
export const EventReminderLogsSchema = z.object({
  created_at: z.string().nullable(),
  error_message: z.string().nullable(),
  event_id: z.string(),
  hours_before: z.number(),
  id: z.string(),
  recipient_email: z.string(),
  recipient_name: z.string().nullable(),
  registration_id: z.string().nullable(),
  reminder_type: z.string(),
  sent_at: z.string().nullable(),
  status: z.string().nullable(),
}).passthrough();

/** public.event_sessions */
export const EventSessionsSchema = z.object({
  capacity: z.number().nullable(),
  created_at: z.string(),
  description: z.string().nullable(),
  end_at: z.string().nullable(),
  event_id: z.string(),
  id: z.string(),
  instructor_ids: z.unknown(),
  location: z.string().nullable(),
  name: z.string(),
  parent_session_id: z.string().nullable(),
  sort_order: z.number(),
  start_at: z.string().nullable(),
  status: z.string(),
  tenant_id: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.event_sponsors */
export const EventSponsorsSchema = z.object({
  created_at: z.string(),
  event_id: z.string(),
  id: z.string(),
  logo_url: z.string().nullable(),
  name: z.string(),
  sort_order: z.number(),
  status: z.string(),
  tenant_id: z.string(),
  tier: z.string().nullable(),
  updated_at: z.string(),
  url: z.string().nullable(),
}).passthrough();

/** public.event_templates */
export const EventTemplatesSchema = z.object({
  category_id: z.string().nullable(),
  created_at: z.string().nullable(),
  created_by: z.string().nullable(),
  description: z.string().nullable(),
  id: z.string(),
  is_active: z.boolean().nullable(),
  name: z.string(),
  template_data: z.unknown(),
  tenant_id: z.string(),
  updated_at: z.string().nullable(),
  usage_count: z.number().nullable(),
}).passthrough();

/** public.event_volunteer_roles */
export const EventVolunteerRolesSchema = z.object({
  capacity: z.number().nullable(),
  created_at: z.string(),
  created_by: z.string().nullable(),
  description: z.string().nullable(),
  end_at: z.string().nullable(),
  event_id: z.string(),
  id: z.string(),
  name: z.string(),
  settings_json: z.unknown(),
  sort_order: z.number(),
  start_at: z.string().nullable(),
  status: z.string(),
  tenant_id: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.event_volunteer_signups */
export const EventVolunteerSignupsSchema = z.object({
  cancellation_token: z.string(),
  cancelled_at: z.string().nullable(),
  confirmed_at: z.string().nullable(),
  created_at: z.string(),
  event_id: z.string(),
  guest_email: z.string().nullable(),
  guest_first_name: z.string().nullable(),
  guest_last_name: z.string().nullable(),
  guest_phone: z.string().nullable(),
  id: z.string(),
  membership_id: z.string().nullable(),
  metadata_json: z.unknown(),
  notes: z.string().nullable(),
  reminder_sent_at: z.string().nullable(),
  role_id: z.string(),
  signed_up_at: z.string(),
  status: z.string(),
  tenant_id: z.string(),
  updated_at: z.string(),
  user_id: z.string().nullable(),
}).passthrough();

/** public.event_waiver_acceptances */
export const EventWaiverAcceptancesSchema = z.object({
  accepted_at: z.string(),
  accepted_by_name: z.string(),
  accepted_ip: z.string().nullable(),
  accepted_user_agent: z.string().nullable(),
  accepted_version: z.number(),
  athlete_id: z.string().nullable(),
  created_at: z.string(),
  event_id: z.string(),
  id: z.string(),
  registration_id: z.string(),
  tenant_id: z.string(),
  waiver_id: z.string(),
}).passthrough();

/** public.event_waivers */
export const EventWaiversSchema = z.object({
  applies_to: z.string(),
  body_html: z.string(),
  created_at: z.string(),
  event_id: z.string(),
  id: z.string(),
  required: z.boolean(),
  sort_order: z.number(),
  status: z.string(),
  tenant_id: z.string(),
  title: z.string(),
  updated_at: z.string(),
  version: z.number(),
  waiver_type: z.string(),
}).passthrough();

/** public.events */
export const EventsSchema = z.object({
  addon_required: z.boolean(),
  addon_selection: z.string(),
  allow_deferred_payment: z.boolean().nullable(),
  auto_cancel_unpaid: z.boolean().nullable(),
  auto_promote_waitlist: z.boolean().nullable(),
  cancellation_policy: z.string().nullable(),
  capacity_alert: z.unknown().nullable(),
  category_id: z.string().nullable(),
  cover_image_url: z.string().nullable(),
  created_at: z.string().nullable(),
  created_by: z.string().nullable(),
  current_registrations: z.number().nullable(),
  dates: z.unknown().nullable(),
  description: z.string().nullable(),
  email_template_overrides: z.unknown(),
  event_subtype: z.string().nullable(),
  event_type: z.string(),
  family_discount_settings: z.unknown(),
  feedback_enabled: z.boolean().nullable(),
  follow_up_settings: z.unknown().nullable(),
  id: z.string(),
  livestream_provider: z.string().nullable(),
  livestream_url: z.string().nullable(),
  location: z.string().nullable(),
  max_registrations: z.number().nullable(),
  members_only: z.boolean().nullable(),
  name: z.string(),
  parent_event_id: z.string().nullable(),
  payment_deadline_days: z.number().nullable(),
  payment_reminder_days: z.number().nullable(),
  pricing_options: z.unknown().nullable(),
  recurrence_rule: z.unknown().nullable(),
  refund_policy_json: z.unknown(),
  registration_deadline: z.string().nullable(),
  reminder_settings: z.unknown().nullable(),
  require_payment_at_registration: z.boolean().nullable(),
  require_positive_balance: z.boolean().nullable(),
  restriction_rules: z.unknown().nullable(),
  series_index: z.number().nullable(),
  session_signup: z.boolean(),
  skill_level: z.string().nullable(),
  spectator_settings: z.unknown(),
  status: z.string().nullable(),
  supply_list: z.unknown().nullable(),
  template_id: z.string().nullable(),
  tenant_id: z.string(),
  updated_at: z.string().nullable(),
  visibility: z.string().nullable(),
  volunteer_reminder_hours_before: z.number(),
  volunteer_signup_audience: z.string(),
  volunteer_signup_enabled: z.boolean(),
  waitlist_enabled: z.boolean().nullable(),
  what_to_bring: z.string().nullable(),
}).passthrough();

/** public.facility_booking_access */
export const FacilityBookingAccessSchema = z.object({
  audience_type: z.string(),
  audience_value: z.string().nullable(),
  created_at: z.string(),
  effect: z.string(),
  id: z.string(),
  is_active: z.boolean(),
  priority: z.number(),
  scope_id: z.string().nullable(),
  scope_type: z.string(),
  tenant_id: z.string(),
}).passthrough();

/** public.facility_booking_audit */
export const FacilityBookingAuditSchema = z.object({
  actor_user_id: z.string().nullable(),
  booking_id: z.string(),
  created_at: z.string(),
  event_type: z.string(),
  id: z.string(),
  payload: z.unknown(),
}).passthrough();

/** public.facility_booking_components */
export const FacilityBookingComponentsSchema = z.object({
  booking_id: z.string(),
  component_kind: z.string(),
  created_at: z.string(),
  id: z.string(),
  metadata: z.unknown(),
  quantity: z.number(),
  resource_id: z.string().nullable(),
  total_price: z.number(),
  unit_price: z.number(),
}).passthrough();

/** public.facility_booking_rules */
export const FacilityBookingRulesSchema = z.object({
  config: z.unknown(),
  created_at: z.string(),
  effective_from: z.string().nullable(),
  effective_to: z.string().nullable(),
  id: z.string(),
  is_active: z.boolean(),
  priority: z.number(),
  rule_type: z.string(),
  scope_id: z.string().nullable(),
  scope_type: z.string(),
  tenant_id: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.facility_booking_waitlist */
export const FacilityBookingWaitlistSchema = z.object({
  created_at: z.string(),
  desired_end_at: z.string(),
  desired_start_at: z.string(),
  guest_email: z.string().nullable(),
  guest_name: z.string().nullable(),
  hold_expires_at: z.string().nullable(),
  hold_token: z.string().nullable(),
  id: z.string(),
  membership_id: z.string().nullable(),
  notes: z.string().nullable(),
  notified_at: z.string().nullable(),
  party_size: z.number(),
  resource_id: z.string(),
  status: z.string(),
  tenant_id: z.string(),
}).passthrough();

/** public.facility_bookings */
export const FacilityBookingsSchema = z.object({
  amount_deposit: z.number(),
  amount_paid: z.number(),
  amount_total: z.number(),
  approval_state: z.string(),
  approved_at: z.string().nullable(),
  approved_by_user_id: z.string().nullable(),
  cancellation_policy_snapshot: z.unknown().nullable(),
  cancellation_reason: z.string().nullable(),
  cancelled_at: z.string().nullable(),
  cancelled_by_user_id: z.string().nullable(),
  created_at: z.string(),
  end_at: z.string(),
  guest_email: z.string().nullable(),
  guest_name: z.string().nullable(),
  guest_phone: z.string().nullable(),
  id: z.string(),
  invoice_id: z.string().nullable(),
  is_quantity_tracked_primary: z.boolean(),
  membership_id: z.string().nullable(),
  metadata: z.unknown(),
  notes: z.string().nullable(),
  party_size: z.number(),
  payment_intent_id: z.string().nullable(),
  payment_status: z.string(),
  primary_resource_id: z.string(),
  recurrence_id: z.string().nullable(),
  recurrence_index: z.number().nullable(),
  reminder_sent_at: z.string().nullable(),
  rules_evaluated: z.unknown().nullable(),
  service_id: z.string().nullable(),
  start_at: z.string(),
  status: z.string(),
  tax_amount: z.number(),
  tenant_id: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.facility_deposit_rules */
export const FacilityDepositRulesSchema = z.object({
  amount_type: z.string(),
  amount_value: z.number(),
  created_at: z.string(),
  due_when: z.string(),
  id: z.string(),
  is_active: z.boolean(),
  priority: z.number(),
  scope_id: z.string().nullable(),
  scope_type: z.string(),
  tenant_id: z.string(),
  updated_at: z.string(),
  waiver_conditions: z.unknown(),
}).passthrough();

/** public.facility_pricing_rules */
export const FacilityPricingRulesSchema = z.object({
  config: z.unknown(),
  created_at: z.string(),
  effective_from: z.string().nullable(),
  effective_to: z.string().nullable(),
  id: z.string(),
  is_active: z.boolean(),
  priority: z.number(),
  rule_type: z.string(),
  scope_id: z.string().nullable(),
  scope_type: z.string(),
  tenant_id: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.facility_resource_blackouts */
export const FacilityResourceBlackoutsSchema = z.object({
  created_at: z.string(),
  created_by_user_id: z.string().nullable(),
  end_at: z.string(),
  id: z.string(),
  reason: z.string().nullable(),
  resource_id: z.string(),
  start_at: z.string(),
  tenant_id: z.string(),
}).passthrough();

/** public.facility_resource_types */
export const FacilityResourceTypesSchema = z.object({
  created_at: z.string(),
  description: z.string().nullable(),
  display_name: z.string(),
  display_order: z.number(),
  id: z.string(),
  image_urls: z.unknown().nullable(),
  is_active: z.boolean(),
  is_quantity_tracked: z.boolean(),
  key: z.string(),
  metadata_schema: z.unknown(),
  tenant_id: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.facility_resources */
export const FacilityResourcesSchema = z.object({
  allow_members_override: z.boolean().nullable(),
  allow_public_override: z.boolean().nullable(),
  buffer_minutes: z.number(),
  capacity: z.number(),
  created_at: z.string(),
  default_approval_mode: z.string(),
  description: z.string().nullable(),
  display_order: z.number(),
  id: z.string(),
  image_urls: z.unknown().nullable(),
  is_active: z.boolean(),
  metadata: z.unknown(),
  name: z.string(),
  resource_type_id: z.string(),
  status: z.string(),
  tenant_id: z.string(),
  updated_at: z.string(),
  visibility: z.string(),
}).passthrough();

/** public.facility_service_components */
export const FacilityServiceComponentsSchema = z.object({
  component_kind: z.string(),
  config: z.unknown(),
  created_at: z.string(),
  display_order: z.number(),
  id: z.string(),
  pricing_inheritance: z.string(),
  quantity: z.number(),
  resource_id: z.string().nullable(),
  resource_type_id: z.string().nullable(),
  service_id: z.string(),
}).passthrough();

/** public.facility_services */
export const FacilityServicesSchema = z.object({
  approval_mode: z.string(),
  created_at: z.string(),
  description: z.string().nullable(),
  duration_minutes: z.number(),
  id: z.string(),
  image_urls: z.unknown().nullable(),
  is_active: z.boolean(),
  metadata: z.unknown(),
  name: z.string(),
  slug: z.string().nullable(),
  tenant_id: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.feedback_forms */
export const FeedbackFormsSchema = z.object({
  created_at: z.string(),
  description: z.string().nullable(),
  email_template_key: z.string(),
  high_score_message: z.string().nullable(),
  id: z.string(),
  is_active: z.boolean(),
  low_score_message: z.string().nullable(),
  name: z.string(),
  notify_user_ids: z.unknown().nullable(),
  recurrence_audience: z.string().nullable(),
  recurrence_cadence_days: z.number().nullable(),
  recurrence_enabled: z.boolean(),
  recurrence_last_run_at: z.string().nullable(),
  review_url_facebook: z.string().nullable(),
  review_url_google: z.string().nullable(),
  review_url_yelp: z.string().nullable(),
  tenant_id: z.string(),
  threshold_pct: z.number().nullable(),
  trigger: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.feedback_questions */
export const FeedbackQuestionsSchema = z.object({
  created_at: z.string(),
  form_id: z.string(),
  id: z.string(),
  options: z.unknown().nullable(),
  position: z.number(),
  prompt: z.string(),
  question_type: z.string(),
  required: z.boolean(),
  scoring_weight: z.number(),
  show_if: z.unknown().nullable(),
}).passthrough();

/** public.feedback_responses */
export const FeedbackResponsesSchema = z.object({
  answers: z.unknown().nullable(),
  created_at: z.string(),
  form_id: z.string(),
  id: z.string(),
  recipient_email: z.string().nullable(),
  recipient_lead_id: z.string().nullable(),
  recipient_membership_id: z.string().nullable(),
  recipient_name: z.string().nullable(),
  routed_to: z.string().nullable(),
  score_pct: z.number().nullable(),
  staff_notified_at: z.string().nullable(),
  submitted_at: z.string().nullable(),
  tenant_id: z.string(),
  token: z.string(),
  token_expires_at: z.string().nullable(),
  trigger_metadata: z.unknown().nullable(),
  trigger_source: z.string().nullable(),
  updated_at: z.string(),
}).passthrough();

/** public.gp_order_submissions */
export const GpOrderSubmissionsSchema = z.object({
  attempt_count: z.number(),
  created_at: z.string(),
  gp_order_id: z.string().nullable(),
  id: z.string(),
  idempotency_key: z.string(),
  last_attempt_at: z.string().nullable(),
  last_error: z.string().nullable(),
  last_status_code: z.number().nullable(),
  max_attempts: z.number(),
  next_attempt_at: z.string(),
  order_id: z.string(),
  payload: z.unknown(),
  status: z.string(),
  submitted_at: z.string().nullable(),
  updated_at: z.string(),
}).passthrough();

/** public.gp_product_visibility */
export const GpProductVisibilitySchema = z.object({
  created_at: z.string().nullable(),
  gp_product_id: z.string(),
  hidden_at: z.string().nullable(),
  hidden_by: z.string().nullable(),
  id: z.string(),
  is_hidden: z.boolean().nullable(),
  product_type: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.held_enrollment_emails */
export const HeldEnrollmentEmailsSchema = z.object({
  athlete_id: z.string(),
  created_at: z.string(),
  end_date: z.string().nullable(),
  enrollment_id: z.string().nullable(),
  id: z.string(),
  membership_id: z.string().nullable(),
  moved_to_slot_id: z.string().nullable(),
  outcome: z.string().nullable(),
  recorded_by: z.string().nullable(),
  release_at: z.string(),
  sent_at: z.string().nullable(),
  slot_id: z.string(),
  status: z.string(),
}).passthrough();

/** public.held_texts */
export const HeldTextsSchema = z.object({
  attempts: z.number(),
  auth_id: z.string().nullable(),
  body: z.string(),
  created_at: z.string(),
  error_message: z.string().nullable(),
  id: z.string(),
  member_message_id: z.string().nullable(),
  membership_id: z.string().nullable(),
  message_sid: z.string().nullable(),
  purpose: z.string(),
  release_at: z.string(),
  sent_at: z.string().nullable(),
  source: z.string(),
  status: z.string(),
  tenant_slug: z.string().nullable(),
  to_phone: z.string(),
}).passthrough();

/** public.hr_documents */
export const HrDocumentsSchema = z.object({
  category: z.string().nullable(),
  content: z.string().nullable(),
  created_at: z.string().nullable(),
  created_by: z.string().nullable(),
  description: z.string().nullable(),
  effective_date: z.string().nullable(),
  file_id: z.string().nullable(),
  id: z.string(),
  is_published: z.boolean().nullable(),
  published_at: z.string().nullable(),
  requires_acknowledgment: z.boolean().nullable(),
  tenant_id: z.string(),
  title: z.string(),
  updated_at: z.string().nullable(),
  updated_by: z.string().nullable(),
  version: z.number().nullable(),
}).passthrough();

/** public.incident_report_addenda */
export const IncidentReportAddendaSchema = z.object({
  body: z.string(),
  created_at: z.string().nullable(),
  created_by: z.string().nullable(),
  id: z.string(),
  incident_id: z.string(),
}).passthrough();

/** public.incident_report_athletes */
export const IncidentReportAthletesSchema = z.object({
  athlete_id: z.string(),
  created_at: z.string().nullable(),
  id: z.string(),
  incident_id: z.string(),
}).passthrough();

/** public.incident_report_attachments */
export const IncidentReportAttachmentsSchema = z.object({
  content_type: z.string().nullable(),
  created_at: z.string().nullable(),
  file_name: z.string(),
  file_size: z.number().nullable(),
  id: z.string(),
  incident_id: z.string(),
  storage_path: z.string(),
  uploaded_by: z.string().nullable(),
}).passthrough();

/** public.incident_report_memberships */
export const IncidentReportMembershipsSchema = z.object({
  created_at: z.string().nullable(),
  id: z.string(),
  incident_id: z.string(),
  membership_id: z.string(),
}).passthrough();

/** public.incident_report_staff */
export const IncidentReportStaffSchema = z.object({
  created_at: z.string().nullable(),
  id: z.string(),
  incident_id: z.string(),
  user_id: z.string(),
}).passthrough();

/** public.incident_reports */
export const IncidentReportsSchema = z.object({
  action_taken: z.string().nullable(),
  archived_at: z.string().nullable(),
  archived_by: z.string().nullable(),
  attendance_date: z.string().nullable(),
  created_at: z.string().nullable(),
  created_by: z.string().nullable(),
  description: z.string(),
  details: z.unknown(),
  follow_up_assigned_to: z.string().nullable(),
  follow_up_completed_at: z.string().nullable(),
  follow_up_completed_by: z.string().nullable(),
  follow_up_due_date: z.string().nullable(),
  follow_up_required: z.boolean(),
  id: z.string(),
  incident_at: z.string(),
  incident_type: z.string(),
  location: z.string().nullable(),
  parent_notified: z.boolean(),
  parent_notified_at: z.string().nullable(),
  parent_notified_by: z.string().nullable(),
  parent_notify_method: z.string().nullable(),
  program_id: z.string().nullable(),
  resolved_at: z.string().nullable(),
  resolved_by: z.string().nullable(),
  severity: z.string(),
  slot_id: z.string().nullable(),
  source: z.string(),
  status: z.string(),
  tenant_id: z.string().nullable(),
  updated_at: z.string().nullable(),
  updated_by: z.string().nullable(),
  witnesses: z.unknown(),
}).passthrough();

/** public.inventory_locations */
export const InventoryLocationsSchema = z.object({
  created_at: z.string(),
  id: z.string(),
  is_active: z.boolean(),
  kind: z.string(),
  name: z.string(),
}).passthrough();

/** public.inventory_movements */
export const InventoryMovementsSchema = z.object({
  created_at: z.string(),
  created_by: z.string().nullable(),
  id: z.string(),
  kind: z.string(),
  location_id: z.string().nullable(),
  note: z.string().nullable(),
  on_hand_after: z.number().nullable(),
  order_id: z.string().nullable(),
  order_item_id: z.string().nullable(),
  product_id: z.string().nullable(),
  quantity: z.number(),
  sku_snapshot: z.string().nullable(),
  unit_cost_cents: z.number().nullable(),
  variant_id: z.string().nullable(),
}).passthrough();

/** public.inventory_movements_legacy */
export const InventoryMovementsLegacySchema = z.object({
  created_at: z.string().nullable(),
  id: z.string(),
  movement_type: z.string(),
  performed_by: z.string().nullable(),
  product_id: z.string(),
  product_type: z.string(),
  quantity_after: z.number(),
  quantity_before: z.number(),
  quantity_change: z.number(),
  reason: z.string().nullable(),
  reference_id: z.string().nullable(),
  reference_type: z.string().nullable(),
  variant_id: z.string().nullable(),
}).passthrough();

/** public.inventory_reservations */
export const InventoryReservationsSchema = z.object({
  converted_at: z.string().nullable(),
  created_at: z.string(),
  expires_at: z.string(),
  id: z.string(),
  order_id: z.string(),
  order_item_id: z.string(),
  quantity: z.number(),
  released_at: z.string().nullable(),
  variant_id: z.string(),
}).passthrough();

/** public.invoice_due_date_repair_20260911 */
export const InvoiceDueDateRepair20260911Schema = z.object({
  applied: z.boolean(),
  invoice_id: z.string(),
  new_due_date: z.string(),
  old_due_date: z.string(),
  repaired_at: z.string(),
}).passthrough();

/** public.invoice_notices */
export const InvoiceNoticesSchema = z.object({
  invoice_id: z.string(),
  sent_at: z.string(),
}).passthrough();

/** public.invoices */
export const InvoicesSchema = z.object({
  amount: z.number().nullable(),
  applies_to_id: z.string().nullable(),
  created_at: z.string().nullable(),
  description: z.string(),
  display_order: z.number().nullable(),
  due_date: z.string(),
  id: z.string(),
  invoice_type: z.string().nullable(),
  isGeneratedBy: z.string().nullable(),
  membership_id: z.string().nullable(),
  metadata: z.unknown().nullable(),
  method: z.string().nullable(),
  note: z.string().nullable(),
  payment_date: z.string().nullable(),
  payment_method: z.string().nullable(),
  post_status: z.string().nullable(),
  processed_by: z.unknown().nullable(),
  receipt_number: z.string().nullable(),
  refund_of: z.string().nullable(),
  responsible_membership_user_id: z.string().nullable(),
  responsible_source: z.string().nullable(),
  source_payment_id: z.string().nullable(),
  status: z.string().nullable(),
  stripe_customer_id: z.string().nullable(),
  tenant_id: z.string().nullable(),
  transaction_id: z.string().nullable(),
  type: z.string().nullable(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.ip_geo_cache */
export const IpGeoCacheSchema = z.object({
  city: z.string().nullable(),
  country_code: z.string().nullable(),
  ip_address: z.string(),
  lat: z.number().nullable(),
  lng: z.number().nullable(),
  looked_up_at: z.string(),
  region: z.string().nullable(),
}).passthrough();

/** public.journal_entries */
export const JournalEntriesSchema = z.object({
  amount_before_tax_cents: z.number().nullable(),
  created_at: z.string(),
  description: z.string().nullable(),
  id: z.string(),
  invoice_id: z.string().nullable(),
  sales_tax_amount_cents: z.number().nullable(),
  sales_tax_name: z.string().nullable(),
  source: z.string(),
  source_id: z.string().nullable(),
  txn_date: z.string(),
}).passthrough();

/** public.journal_lines */
export const JournalLinesSchema = z.object({
  account_id: z.string(),
  created_at: z.string(),
  credit_cents: z.number(),
  debit_cents: z.number(),
  id: z.string(),
  journal_entry_id: z.string(),
  line_description: z.string().nullable(),
}).passthrough();

/** public.kiosk_config */
export const KioskConfigSchema = z.object({
  created_at: z.string(),
  created_by: z.string().nullable(),
  id: z.string(),
  is_enabled: z.boolean(),
  pin_hash: z.string(),
  pin_length: z.number(),
  require_athlete_pin: z.boolean(),
  staff_mode_enabled: z.boolean(),
  tenant_id: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.kiosk_devices */
export const KioskDevicesSchema = z.object({
  created_at: z.string(),
  device_name: z.string().nullable(),
  device_token: z.string(),
  id: z.string(),
  is_active: z.boolean(),
  last_used_at: z.string().nullable(),
  tenant_id: z.string(),
}).passthrough();

/** public.levels */
export const LevelsSchema = z.object({
  color: z.string().nullable(),
  created_at: z.string().nullable(),
  description: z.string().nullable(),
  display_order: z.number().nullable(),
  id: z.string(),
  name: z.string(),
  status: z.string().nullable(),
  tenant_id: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.lms_awards */
export const LmsAwardsSchema = z.object({
  athlete_id: z.string(),
  award_type: z.string(),
  course_source: z.string(),
  description: z.string().nullable(),
  enrollment_id: z.string().nullable(),
  gp_award_id: z.string().nullable(),
  id: z.string(),
  image_url: z.string().nullable(),
  issued_at: z.string().nullable(),
  title: z.string(),
}).passthrough();

/** public.lms_course_lessons */
export const LmsCourseLessonsSchema = z.object({
  content: z.unknown(),
  course_id: z.string(),
  created_at: z.string(),
  description: z.string().nullable(),
  duration_minutes: z.number().nullable(),
  id: z.string(),
  is_preview: z.boolean(),
  lesson_type: z.string(),
  order: z.number(),
  section_id: z.string(),
  title: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.lms_course_quiz_questions */
export const LmsCourseQuizQuestionsSchema = z.object({
  correct_answer: z.string(),
  created_at: z.string(),
  id: z.string(),
  options: z.unknown().nullable(),
  order: z.number(),
  points: z.number(),
  question: z.string(),
  question_type: z.string(),
  quiz_id: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.lms_course_quizzes */
export const LmsCourseQuizzesSchema = z.object({
  course_id: z.string(),
  created_at: z.string(),
  description: z.string().nullable(),
  id: z.string(),
  order: z.number(),
  passing_score: z.number().nullable(),
  section_id: z.string(),
  time_limit_minutes: z.number().nullable(),
  title: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.lms_course_sections */
export const LmsCourseSectionsSchema = z.object({
  course_id: z.string(),
  created_at: z.string(),
  description: z.string().nullable(),
  id: z.string(),
  order: z.number(),
  title: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.lms_courses */
export const LmsCoursesSchema = z.object({
  category: z.string().nullable(),
  completion_requirements: z.unknown().nullable(),
  context: z.string(),
  created_at: z.string().nullable(),
  created_by: z.string().nullable(),
  description: z.string().nullable(),
  difficulty: z.string().nullable(),
  duration_hours: z.number().nullable(),
  final_quiz_id: z.string().nullable(),
  id: z.string(),
  image_url: z.string().nullable(),
  passing_score: z.number().nullable(),
  prerequisites: z.unknown().nullable(),
  published: z.boolean().nullable(),
  title: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.lms_enrollments */
export const LmsEnrollmentsSchema = z.object({
  athlete_id: z.string(),
  completed_at: z.string().nullable(),
  course_id: z.string().nullable(),
  course_source: z.string(),
  created_at: z.string().nullable(),
  enrolled_at: z.string().nullable(),
  enrolled_by: z.string().nullable(),
  gp_course_id: z.string().nullable(),
  id: z.string(),
  progress: z.number().nullable(),
  status: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.lms_lesson_progress */
export const LmsLessonProgressSchema = z.object({
  completed_at: z.string().nullable(),
  course_source: z.string(),
  enrollment_id: z.string(),
  id: z.string(),
  lesson_id: z.string(),
}).passthrough();

/** public.lms_quiz_attempts */
export const LmsQuizAttemptsSchema = z.object({
  answers: z.unknown().nullable(),
  attempted_at: z.string().nullable(),
  course_source: z.string(),
  enrollment_id: z.string(),
  id: z.string(),
  max_score: z.number(),
  passed: z.boolean().nullable(),
  quiz_id: z.string(),
  score: z.number(),
}).passthrough();

/** public.magic_link_tokens */
export const MagicLinkTokensSchema = z.object({
  auth_source: z.string(),
  created_at: z.string().nullable(),
  email: z.string(),
  expires_at: z.string(),
  id: z.string(),
  token: z.string(),
  used_at: z.string().nullable(),
  user_id: z.string(),
}).passthrough();

/** public.mailersend_webhook_events */
export const MailersendWebhookEventsSchema = z.object({
  activity_id: z.string(),
  error_message: z.string().nullable(),
  event_type: z.string().nullable(),
  id: z.string(),
  message_id: z.string().nullable(),
  processed_at: z.string().nullable(),
  received_at: z.string(),
  recipient: z.string().nullable(),
  status: z.string(),
}).passthrough();

/** public.marketing_campaigns */
export const MarketingCampaignsSchema = z.object({
  audience_emails: z.unknown().nullable(),
  audience_segment_id: z.string().nullable(),
  audience_spec: z.unknown().nullable(),
  created_at: z.string(),
  created_by: z.string().nullable(),
  goal_text: z.string().nullable(),
  id: z.string(),
  metadata: z.unknown(),
  name: z.string(),
  published_at: z.string().nullable(),
  status: z.string(),
  tenant_id: z.string(),
  tone: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.marketing_contacts */
export const MarketingContactsSchema = z.object({
  address: z.string().nullable(),
  city: z.string().nullable(),
  created_at: z.string().nullable(),
  created_by: z.string().nullable(),
  email: z.string().nullable(),
  first_name: z.string().nullable(),
  formatted_address: z.string().nullable(),
  id: z.string(),
  is_subscribed: z.boolean().nullable(),
  last_name: z.string().nullable(),
  metadata: z.unknown(),
  notes: z.string().nullable(),
  phone: z.string().nullable(),
  source: z.string().nullable(),
  state: z.string().nullable(),
  tenant_id: z.string(),
  unsubscribed_at: z.string().nullable(),
  updated_at: z.string().nullable(),
  zip: z.string().nullable(),
}).passthrough();

/** public.media_library */
export const MediaLibrarySchema = z.object({
  bucket: z.string(),
  created_at: z.string().nullable(),
  id: z.string(),
  name: z.string(),
  path: z.string(),
  tags: z.unknown().nullable(),
  type: z.string(),
  uploaded_by: z.string().nullable(),
}).passthrough();

/** public.media_shares */
export const MediaSharesSchema = z.object({
  created_at: z.string(),
  expires_at: z.string().nullable(),
  folder_path: z.string().nullable(),
  id: z.string(),
  media_id: z.string().nullable(),
  note: z.string().nullable(),
  permission: z.string(),
  share_token: z.string().nullable(),
  share_type: z.string(),
  shared_by: z.string(),
  shared_by_name: z.string().nullable(),
  shared_with_user_id: z.string().nullable(),
  updated_at: z.string(),
}).passthrough();

/** public.member_billing_notes */
export const MemberBillingNotesSchema = z.object({
  created_at: z.string().nullable(),
  id: z.string(),
  is_starred: z.boolean().nullable(),
  membership_id: z.string().nullable(),
  metadata: z.unknown().nullable(),
  note: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.member_messages */
export const MemberMessagesSchema = z.object({
  bounce_type: z.string().nullable(),
  bounced_at: z.string().nullable(),
  clicked_at: z.string().nullable(),
  created_at: z.string().nullable(),
  delivered_at: z.string().nullable(),
  error_message: z.string().nullable(),
  id: z.string(),
  mailersend_message_id: z.string().nullable(),
  membership_id: z.string().nullable(),
  message: z.string(),
  metadata: z.unknown().nullable(),
  opened_at: z.string().nullable(),
  sent_at: z.string().nullable(),
  status: z.string().nullable(),
  subject: z.string(),
  type: z.string().nullable(),
  updated_at: z.string().nullable(),
  user_id: z.string().nullable(),
}).passthrough();

/** public.membership_actions */
export const MembershipActionsSchema = z.object({
  action_type_id: z.string().nullable(),
  assigned_to: z.string().nullable(),
  athlete_id: z.string().nullable(),
  completed_at: z.string().nullable(),
  completed_by: z.string().nullable(),
  created_at: z.string().nullable(),
  created_by: z.string(),
  description: z.string().nullable(),
  due_date: z.string().nullable(),
  event_id: z.string().nullable(),
  id: z.string(),
  incident_id: z.string().nullable(),
  membership_id: z.string().nullable(),
  metadata: z.unknown().nullable(),
  onboarding_workflow_id: z.string().nullable(),
  parent_task_id: z.string().nullable(),
  position: z.number(),
  priority: z.string().nullable(),
  status: z.string().nullable(),
  subject_user_id: z.string().nullable(),
  tenant_id: z.string(),
  title: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.membership_annual_fees */
export const MembershipAnnualFeesSchema = z.object({
  amount: z.number(),
  created_at: z.string().nullable(),
  due_date: z.string(),
  id: z.string(),
  membership_id: z.string(),
  payment_date: z.string(),
  status: z.string().nullable(),
  stripe_payment_intent_id: z.string().nullable(),
  tenant_id: z.string().nullable(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.membership_audit_log */
export const MembershipAuditLogSchema = z.object({
  action: z.string(),
  actor_auth_id: z.string().nullable(),
  actor_role: z.string(),
  created_at: z.string(),
  details: z.unknown(),
  id: z.string(),
  ip_address: z.string().nullable(),
  membership_id: z.string(),
  target_membership_user_id: z.string().nullable(),
  tenant_id: z.string().nullable(),
  user_agent: z.string().nullable(),
}).passthrough();

/** public.membership_deletion_log */
export const MembershipDeletionLogSchema = z.object({
  deleted_at: z.string(),
  deleted_by: z.string().nullable(),
  deleted_by_name: z.string().nullable(),
  deleted_membership_email: z.string().nullable(),
  deleted_membership_id: z.string(),
  deleted_membership_name: z.string().nullable(),
  deleted_membership_snapshot: z.unknown(),
  id: z.string(),
  reason: z.string().nullable(),
  related_counts: z.unknown().nullable(),
  tenant_id: z.string().nullable(),
}).passthrough();

/** public.membership_payment_assignments */
export const MembershipPaymentAssignmentsSchema = z.object({
  created_at: z.string(),
  created_by_auth_id: z.string().nullable(),
  id: z.string(),
  membership_id: z.string(),
  membership_user_id: z.string(),
  purpose: z.string(),
  tenant_id: z.string().nullable(),
  updated_at: z.string(),
  year_month: z.string(),
}).passthrough();

/** public.membership_user_permissions */
export const MembershipUserPermissionsSchema = z.object({
  created_at: z.string(),
  edit_athletes: z.boolean(),
  edit_membership_settings: z.boolean(),
  edit_payment_methods_others: z.boolean(),
  edit_payment_methods_own: z.boolean(),
  manage_secondary_users: z.boolean(),
  membership_user_id: z.string(),
  updated_at: z.string(),
  view_address: z.boolean(),
  view_athlete_info: z.boolean(),
  view_billing_history: z.boolean(),
  view_other_contact_info: z.boolean(),
  view_other_payment_methods: z.boolean(),
}).passthrough();

/** public.membership_users */
export const MembershipUsersSchema = z.object({
  accepted_at: z.string().nullable(),
  auth_id: z.string().nullable(),
  created_at: z.string(),
  expires_at: z.string().nullable(),
  id: z.string(),
  invitation_email: z.string().nullable(),
  invitation_first_name: z.string().nullable(),
  invitation_last_name: z.string().nullable(),
  invitation_token: z.string().nullable(),
  invitation_token_hash: z.string().nullable(),
  invited_at: z.string().nullable(),
  invited_by_auth_id: z.string().nullable(),
  membership_id: z.string(),
  notes: z.string().nullable(),
  revoked_at: z.string().nullable(),
  role: z.string(),
  status: z.string(),
  stripe_customer_id: z.string().nullable(),
  updated_at: z.string(),
}).passthrough();

/** public.membership_vacations */
export const MembershipVacationsSchema = z.object({
  athlete_id: z.string().nullable(),
  billing_mode: z.string(),
  created_at: z.string().nullable(),
  created_by: z.string().nullable(),
  id: z.string(),
  member_reminder_sent_at: z.string().nullable(),
  membership_id: z.string(),
  reason: z.string().nullable(),
  remind_member: z.boolean(),
  remind_staff: z.boolean(),
  reminder_channels: z.unknown(),
  reminder_days_before: z.number(),
  return_date: z.string(),
  staff_reminder_sent_at: z.string().nullable(),
  start_date: z.string(),
  status: z.string(),
  tenant_id: z.string().nullable(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.memberships */
export const MembershipsSchema = z.object({
  account_flag_reason: z.string().nullable(),
  account_flagged: z.boolean(),
  account_type: z.string(),
  action_required: z.string().nullable(),
  address: z.string().nullable(),
  alternate_email: z.string().nullable(),
  alternate_email_2: z.string().nullable(),
  alternate_phone: z.string().nullable(),
  alternate_phone_digits: z.string().nullable(),
  annual_registration_month: z.string().nullable(),
  auth_id: z.string().nullable(),
  balance: z.number(),
  billing_highlight_note: z.string().nullable(),
  billing_notes: z.string().nullable(),
  cancellation_reason: z.string().nullable(),
  cancellation_scheduled_at: z.string().nullable(),
  cancellation_scheduled_by: z.string().nullable(),
  carrier: z.string().nullable(),
  city: z.string().nullable(),
  created_at: z.string().nullable(),
  created_via: z.string().nullable(),
  email: z.string(),
  email_verification_reason: z.string().nullable(),
  email_verification_status: z.string().nullable(),
  email_verified_at: z.string().nullable(),
  first_name: z.string().nullable(),
  formatted_address: z.string().nullable(),
  geocoded_at: z.string().nullable(),
  has_saved_payment_method: z.boolean().nullable(),
  id: z.string(),
  last_name: z.string().nullable(),
  lat: z.number().nullable(),
  lead_archived_at: z.string().nullable(),
  lead_assigned_to: z.string().nullable(),
  lead_last_contacted_at: z.string().nullable(),
  lead_last_contacted_by: z.string().nullable(),
  lead_last_contacted_via: z.string().nullable(),
  lead_lost_at: z.string().nullable(),
  lead_lost_reason: z.string().nullable(),
  lead_metadata: z.unknown().nullable(),
  lead_source: z.string().nullable(),
  lead_stage: z.string().nullable(),
  lead_stage_changed_at: z.string().nullable(),
  lng: z.number().nullable(),
  metadata: z.unknown(),
  mobile_sms: z.string().nullable(),
  mobile_sms_digits: z.string().nullable(),
  old_membership_id: z.string().nullable(),
  phone: z.string().nullable(),
  phone_digits: z.string().nullable(),
  place_id: z.string().nullable(),
  referral: z.string().nullable(),
  referral_type: z.string().nullable(),
  referrer_membership_id: z.string().nullable(),
  saved_payment_method_checked_at: z.string().nullable(),
  scheduled_cancellation_date: z.string().nullable(),
  settings: z.unknown().nullable(),
  sms_opt_in_at: z.string().nullable(),
  sms_opt_in_source: z.string().nullable(),
  sms_opt_in_version: z.string().nullable(),
  sms_opt_out_at: z.string().nullable(),
  source_lead_id: z.string().nullable(),
  start_date: z.string().nullable(),
  state: z.string().nullable(),
  status: z.string().nullable(),
  stripe_customer_id: z.string().nullable(),
  support_pin_failed_attempts: z.number(),
  support_pin_hash: z.string().nullable(),
  support_pin_locked_until: z.string().nullable(),
  support_pin_reset_token: z.string().nullable(),
  support_pin_reset_token_expires_at: z.string().nullable(),
  support_pin_set_at: z.string().nullable(),
  tenant_id: z.string().nullable(),
  trial_athlete_dob: z.string().nullable(),
  trial_athlete_first_name: z.string().nullable(),
  trial_athlete_gender: z.string().nullable(),
  trial_athlete_last_name: z.string().nullable(),
  trial_date: z.string().nullable(),
  trial_followup_sent_at: z.string().nullable(),
  trial_program_id: z.string().nullable(),
  trial_slot_id: z.string().nullable(),
  updated_at: z.string().nullable(),
  zip: z.string().nullable(),
}).passthrough();

/** public.merchandise */
export const MerchandiseSchema = z.object({
  barcode: z.string().nullable(),
  category: z.string(),
  created_at: z.string().nullable(),
  description: z.string().nullable(),
  featured: z.boolean().nullable(),
  has_variants: z.boolean().nullable(),
  id: z.string(),
  image: z.string().nullable(),
  image_gallery: z.unknown().nullable(),
  inventory: z.number(),
  low_stock_threshold: z.number().nullable(),
  name: z.string(),
  price: z.number(),
  sku: z.string().nullable(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.notifications */
export const NotificationsSchema = z.object({
  created_at: z.string().nullable(),
  id: z.string(),
  is_read: z.boolean().nullable(),
  link: z.string().nullable(),
  message: z.string().nullable(),
  notification_type: z.string(),
  read_at: z.string().nullable(),
  related_entity_id: z.string().nullable(),
  related_entity_type: z.string().nullable(),
  tenant_id: z.string(),
  title: z.string(),
  user_id: z.string(),
}).passthrough();

/** public.onboarding_status */
export const OnboardingStatusSchema = z.object({
  id: z.string(),
  page_key: z.string(),
  status: z.string(),
  updated_at: z.string().nullable(),
  user_id: z.string(),
}).passthrough();

/** public.onboarding_template_tasks */
export const OnboardingTemplateTasksSchema = z.object({
  assigned_to_role: z.string().nullable(),
  created_at: z.string().nullable(),
  description: z.string().nullable(),
  due_days_offset: z.number().nullable(),
  id: z.string(),
  is_required: z.boolean().nullable(),
  requires_document_upload: z.boolean().nullable(),
  sort_order: z.number().nullable(),
  template_id: z.string(),
  title: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.onboarding_templates */
export const OnboardingTemplatesSchema = z.object({
  created_at: z.string().nullable(),
  created_by: z.string().nullable(),
  description: z.string().nullable(),
  id: z.string(),
  is_active: z.boolean().nullable(),
  name: z.string(),
  role_id: z.string().nullable(),
  tenant_id: z.string(),
  type: z.string().nullable(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.onboarding_workflow_tasks */
export const OnboardingWorkflowTasksSchema = z.object({
  assigned_to: z.string().nullable(),
  completed_at: z.string().nullable(),
  completed_by: z.string().nullable(),
  created_at: z.string().nullable(),
  description: z.string().nullable(),
  document_id: z.string().nullable(),
  due_date: z.string().nullable(),
  id: z.string(),
  is_required: z.boolean().nullable(),
  notes: z.string().nullable(),
  requires_document_upload: z.boolean().nullable(),
  sort_order: z.number().nullable(),
  status: z.string().nullable(),
  template_task_id: z.string().nullable(),
  title: z.string(),
  updated_at: z.string().nullable(),
  workflow_id: z.string(),
}).passthrough();

/** public.onboarding_workflows */
export const OnboardingWorkflowsSchema = z.object({
  completed_at: z.string().nullable(),
  created_at: z.string().nullable(),
  employee_profile_id: z.string(),
  id: z.string(),
  started_at: z.string().nullable(),
  started_by: z.string().nullable(),
  status: z.string().nullable(),
  template_id: z.string().nullable(),
  tenant_id: z.string(),
  type: z.string().nullable(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.order_items */
export const OrderItemsSchema = z.object({
  created_at: z.string().nullable(),
  download_count: z.number().nullable(),
  download_url: z.string().nullable(),
  gp_product_id: z.string().nullable(),
  id: z.string(),
  is_digital: z.boolean().nullable(),
  max_downloads: z.number().nullable(),
  metadata: z.unknown().nullable(),
  name_snapshot: z.string().nullable(),
  order_id: z.string(),
  price_cents_snapshot: z.number().nullable(),
  product_description: z.string().nullable(),
  product_id: z.string(),
  product_image: z.string().nullable(),
  product_name: z.string(),
  product_sku: z.string().nullable(),
  product_source: z.string(),
  product_type: z.string(),
  quantity: z.number(),
  recipient_name: z.string().nullable(),
  total_price: z.number(),
  unit_price: z.number(),
  variant_id: z.string().nullable(),
  variant_label_snapshot: z.string().nullable(),
}).passthrough();

/** public.order_status_history */
export const OrderStatusHistorySchema = z.object({
  change_reason: z.string().nullable(),
  changed_by: z.string().nullable(),
  created_at: z.string().nullable(),
  id: z.string(),
  metadata: z.unknown().nullable(),
  new_status: z.string(),
  order_id: z.string(),
  previous_status: z.string().nullable(),
}).passthrough();

/** public.orders */
export const OrdersSchema = z.object({
  billing_address: z.unknown().nullable(),
  cancelled_at: z.string().nullable(),
  created_at: z.string().nullable(),
  currency: z.string(),
  customer_email: z.string(),
  customer_name: z.string(),
  customer_phone: z.string().nullable(),
  delivered_at: z.string().nullable(),
  discount_amount: z.number().nullable(),
  discount_cents: z.number().nullable(),
  fulfillment_status: z.string(),
  gp_order_id: z.string().nullable(),
  gp_order_status: z.string().nullable(),
  has_gp_items: z.boolean().nullable(),
  id: z.string(),
  internal_notes: z.string().nullable(),
  invoice_id: z.string().nullable(),
  is_pos_sale: z.boolean(),
  membership_id: z.string().nullable(),
  metadata: z.unknown().nullable(),
  notes: z.string().nullable(),
  order_number: z.string(),
  paid_at: z.string().nullable(),
  payment_method: z.string().nullable(),
  payment_status: z.string().nullable(),
  shipped_at: z.string().nullable(),
  shipping_address: z.unknown().nullable(),
  shipping_amount: z.number().nullable(),
  shipping_cents: z.number().nullable(),
  shipping_method_label: z.string().nullable(),
  status: z.string().nullable(),
  store_channel: z.string(),
  stripe_charge_id: z.string().nullable(),
  stripe_payment_intent_id: z.string().nullable(),
  subtotal: z.number(),
  subtotal_cents: z.number().nullable(),
  tax_amount: z.number().nullable(),
  tax_cents: z.number().nullable(),
  tax_rate: z.number().nullable(),
  total_amount: z.number(),
  total_cents: z.number().nullable(),
  updated_at: z.string().nullable(),
  user_id: z.string().nullable(),
}).passthrough();

/** public.password_reset_tokens */
export const PasswordResetTokensSchema = z.object({
  created_at: z.string().nullable(),
  email: z.string(),
  expires_at: z.string(),
  id: z.string(),
  token: z.string(),
  used_at: z.string().nullable(),
  user_id: z.string(),
}).passthrough();

/** public.past_due_notices */
export const PastDueNoticesSchema = z.object({
  amount_owed: z.number(),
  channel: z.string().nullable(),
  days_owing: z.number(),
  id: z.string(),
  membership_id: z.string(),
  owing_since: z.string(),
  repeat_number: z.number(),
  sent_at: z.string(),
  stage: z.number(),
  template: z.string(),
}).passthrough();

/** public.payment_intents */
export const PaymentIntentsSchema = z.object({
  amount: z.number(),
  created_at: z.string().nullable(),
  id: z.string(),
  invoice_id: z.string().nullable(),
  membership_id: z.string().nullable(),
  status: z.string().nullable(),
  stripe_payment_intent_id: z.string(),
  tenant_id: z.string().nullable(),
}).passthrough();

/** public.payment_method_purposes */
export const PaymentMethodPurposesSchema = z.object({
  created_at: z.string(),
  id: z.string(),
  membership_id: z.string(),
  membership_user_id: z.string().nullable(),
  purpose: z.string(),
  stripe_payment_method_id: z.string(),
  tenant_id: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.payments */
export const PaymentsSchema = z.object({
  amount: z.number().nullable(),
  created_at: z.string().nullable(),
  id: z.string(),
  invoice_id: z.string().nullable(),
  membership_id: z.string().nullable(),
  metadata: z.unknown().nullable(),
  note: z.string().nullable(),
  payment_date: z.string().nullable(),
  payment_method: z.string().nullable(),
  payment_type: z.string().nullable(),
  receipt_number: z.string().nullable(),
  status: z.string().nullable(),
  stripe_customer_id: z.string().nullable(),
  tenant_id: z.string().nullable(),
  transaction_id: z.string().nullable(),
  type: z.string().nullable(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.payroll_settings */
export const PayrollSettingsSchema = z.object({
  config: z.unknown().nullable(),
  created_at: z.string().nullable(),
  enabled: z.boolean().nullable(),
  id: z.string(),
  provider: z.string().nullable(),
  tenant_id: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.permissions */
export const PermissionsSchema = z.object({
  category: z.string().nullable(),
  delegatable: z.boolean(),
  description: z.string().nullable(),
  id: z.string(),
  is_system: z.boolean(),
  name: z.string(),
  owner_only: z.boolean(),
  tenant_id: z.string().nullable(),
}).passthrough();

/** public.post_comments */
export const PostCommentsSchema = z.object({
  approved_at: z.string().nullable(),
  approved_by_user_id: z.string().nullable(),
  author_email: z.string().nullable(),
  author_membership_id: z.string().nullable(),
  author_name: z.string().nullable(),
  author_user_id: z.string().nullable(),
  body: z.string(),
  created_at: z.string(),
  hidden_at: z.string().nullable(),
  hidden_by_user_id: z.string().nullable(),
  hidden_reason: z.string().nullable(),
  id: z.string(),
  post_id: z.string(),
  status: z.string(),
  tenant_id: z.string().nullable(),
  updated_at: z.string(),
}).passthrough();

/** public.post_reactions */
export const PostReactionsSchema = z.object({
  author_membership_id: z.string().nullable(),
  author_user_id: z.string().nullable(),
  created_at: z.string(),
  id: z.string(),
  post_id: z.string(),
  reaction_type: z.string(),
  tenant_id: z.string().nullable(),
  updated_at: z.string(),
}).passthrough();

/** public.posts */
export const PostsSchema = z.object({
  author_id: z.string().nullable(),
  categories: z.unknown().nullable(),
  comments_enabled: z.boolean().nullable(),
  content: z.string().nullable(),
  created_at: z.string().nullable(),
  excerpt: z.string().nullable(),
  featured_image: z.string().nullable(),
  id: z.string(),
  published_at: z.string().nullable(),
  reactions_enabled: z.boolean().nullable(),
  seo_description: z.string().nullable(),
  seo_title: z.string().nullable(),
  slug: z.string(),
  status: z.string().nullable(),
  tenant_id: z.string(),
  title: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.pricing_tiers */
export const PricingTiersSchema = z.object({
  created_at: z.string(),
  display_name: z.string().nullable(),
  hours: z.number(),
  id: z.string(),
  is_active: z.boolean(),
  price: z.number(),
  sort_order: z.number().nullable(),
  tenant_id: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.private_session_athletes */
export const PrivateSessionAthletesSchema = z.object({
  athlete_id: z.string(),
  attendance_status: z.string().nullable(),
  id: z.string(),
  session_id: z.string(),
}).passthrough();

/** public.private_sessions */
export const PrivateSessionsSchema = z.object({
  booked_by: z.string().nullable(),
  created_at: z.string().nullable(),
  duration_minutes: z.number(),
  id: z.string(),
  instructor_id: z.string().nullable(),
  invoice_id: z.string().nullable(),
  membership_id: z.string(),
  name: z.string().nullable(),
  notes: z.string().nullable(),
  price: z.number(),
  price_override: z.boolean().nullable(),
  session_date: z.string(),
  start_time: z.string(),
  status: z.string().nullable(),
  tenant_id: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.product_cost_changes */
export const ProductCostChangesSchema = z.object({
  applied_at: z.string().nullable(),
  cost_cents: z.number(),
  created_at: z.string(),
  created_by: z.string().nullable(),
  effective_at: z.string(),
  id: z.string(),
  note: z.string().nullable(),
  product_id: z.string(),
  source_ref: z.string().nullable(),
  status: z.string(),
  supplier_id: z.string().nullable(),
  variant_id: z.string().nullable(),
}).passthrough();

/** public.product_cost_history */
export const ProductCostHistorySchema = z.object({
  cost_cents: z.number(),
  currency: z.string(),
  effective_at: z.string(),
  id: z.string(),
  previous_cost_cents: z.number().nullable(),
  product_cost_id: z.string().nullable(),
  product_id: z.string().nullable(),
  recorded_at: z.string(),
  recorded_by: z.string().nullable(),
  source: z.string(),
  source_ref: z.string().nullable(),
  supplier_id: z.string().nullable(),
  variant_id: z.string().nullable(),
}).passthrough();

/** public.product_cost_reviews */
export const ProductCostReviewsSchema = z.object({
  created_at: z.string(),
  current_cost_cents: z.number().nullable(),
  decided_at: z.string().nullable(),
  decided_by: z.string().nullable(),
  id: z.string(),
  product_id: z.string(),
  proposed_cost_cents: z.number(),
  reason: z.string(),
  source_ref: z.string().nullable(),
  status: z.string(),
  supplier_id: z.string().nullable(),
  unit: z.string().nullable(),
  variant_id: z.string().nullable(),
}).passthrough();

/** public.product_costs */
export const ProductCostsSchema = z.object({
  confirmed_at: z.string().nullable(),
  cost_cents: z.number(),
  cost_updated_at: z.string(),
  created_at: z.string(),
  currency: z.string(),
  id: z.string(),
  pinned: z.boolean(),
  product_id: z.string(),
  source: z.string(),
  source_ref: z.string().nullable(),
  supplier_id: z.string().nullable(),
  supplier_item_id: z.string().nullable(),
  unit: z.string().nullable(),
  updated_by: z.string().nullable(),
  variant_id: z.string().nullable(),
}).passthrough();

/** public.product_variants */
export const ProductVariantsSchema = z.object({
  attributes: z.unknown().nullable(),
  barcode: z.string().nullable(),
  created_at: z.string().nullable(),
  id: z.string(),
  image: z.string().nullable(),
  inventory: z.number().nullable(),
  is_active: z.boolean().nullable(),
  low_stock_threshold: z.number().nullable(),
  name: z.string().nullable(),
  price_cents: z.number().nullable(),
  price_override: z.number().nullable(),
  product_id: z.string(),
  product_type: z.string(),
  quantity_scale: z.number(),
  sku: z.string().nullable(),
  sort_order: z.number().nullable(),
  stock: z.number().nullable(),
  updated_at: z.string().nullable(),
  variant_name: z.string().nullable(),
}).passthrough();

/** public.products */
export const ProductsSchema = z.object({
  barcode: z.string().nullable(),
  category: z.string().nullable(),
  created_at: z.string(),
  currency: z.string(),
  description: z.string().nullable(),
  featured: z.boolean(),
  has_variants: z.boolean(),
  id: z.string(),
  image: z.string().nullable(),
  image_gallery: z.unknown(),
  is_published: z.boolean(),
  kind: z.string(),
  low_stock_threshold: z.number().nullable(),
  name: z.string(),
  price_cents: z.number().nullable(),
  sku: z.string().nullable(),
  updated_at: z.string(),
}).passthrough();

/** public.program_categories */
export const ProgramCategoriesSchema = z.object({
  background_color: z.string().nullable(),
  background_image_url: z.string().nullable(),
  created_at: z.string().nullable(),
  description: z.string().nullable(),
  id: z.string(),
  name: z.string(),
  sort_order: z.number(),
  visibility: z.string(),
}).passthrough();

/** public.program_enrollment_events */
export const ProgramEnrollmentEventsSchema = z.object({
  dependent_id: z.string().nullable(),
  enrollment_id: z.string().nullable(),
  event_at: z.string(),
  event_reason: z.string().nullable(),
  event_type: z.string(),
  id: z.string(),
  recorded_by: z.string().nullable(),
  slot_id: z.string(),
  user_id: z.string(),
}).passthrough();

/** public.program_enrollments */
export const ProgramEnrollmentsSchema = z.object({
  archived_at: z.string().nullable(),
  dependent_id: z.string().nullable(),
  enrolled_at: z.string(),
  id: z.string(),
  scheduled_unenroll_date: z.string().nullable(),
  slot_id: z.string(),
  start_date: z.string(),
  status: z.string(),
  tenant_id: z.string().nullable(),
  unenroll_reason: z.string().nullable(),
  unenroll_scheduled_at: z.string().nullable(),
  unenroll_scheduled_by: z.string().nullable(),
  user_id: z.string(),
}).passthrough();

/** public.program_pricing_config */
export const ProgramPricingConfigSchema = z.object({
  created_at: z.string().nullable(),
  days_late_before_applying: z.number().nullable(),
  enable_sibling_discount: z.boolean().nullable(),
  id: z.string(),
  late_fee_type: z.string().nullable(),
  late_fee_value: z.number().nullable(),
  referral_credit: z.number().nullable(),
  registration_fee: z.number().nullable(),
  sibling_discount_model: z.string(),
  sibling_discount_percent: z.number().nullable(),
  sibling_discount_value_type: z.string(),
  tenant_id: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.program_slots */
export const ProgramSlotsSchema = z.object({
  archived_at: z.string().nullable(),
  archived_by: z.string().nullable(),
  available_for_registration: z.boolean(),
  capacity_full_alerted_at: z.string().nullable(),
  capacity_warn_alerted_at: z.string().nullable(),
  created_at: z.string().nullable(),
  days: z.unknown(),
  duration_hours: z.number().nullable(),
  id: z.string(),
  max_enrollment: z.number().nullable(),
  program_id: z.string().nullable(),
  slot_frequency: z.string(),
  slot_frequency_days: z.number(),
  slot_id: z.string(),
  status: z.string(),
  tenant_id: z.string().nullable(),
  times: z.unknown(),
  updated_at: z.string().nullable(),
  updated_by: z.string().nullable(),
}).passthrough();

/** public.programs */
export const ProgramsSchema = z.object({
  archived_at: z.string().nullable(),
  archived_by: z.string().nullable(),
  available_for_registration: z.boolean(),
  category_id: z.string().nullable(),
  created_at: z.string().nullable(),
  description: z.string().nullable(),
  featured: z.boolean(),
  featured_sort_order: z.number(),
  hours_per_week: z.number().nullable(),
  id: z.string(),
  image_url: z.string().nullable(),
  key: z.string(),
  label: z.string(),
  max_age: z.number().nullable(),
  min_age: z.number().nullable(),
  participant_type: z.string(),
  tenant_id: z.string().nullable(),
  updated_at: z.string().nullable(),
  visibility: z.string(),
}).passthrough();

/** public.purchase_order_lines */
export const PurchaseOrderLinesSchema = z.object({
  created_at: z.string(),
  description: z.string(),
  id: z.string(),
  line_total_cents: z.number().nullable(),
  position: z.number(),
  product_id: z.string().nullable(),
  purchase_order_id: z.string(),
  quantity: z.number(),
  quantity_scale: z.number(),
  unit_cost_cents: z.number().nullable(),
  variant_id: z.string().nullable(),
}).passthrough();

/** public.purchase_order_receipts */
export const PurchaseOrderReceiptsSchema = z.object({
  created_at: z.string(),
  id: z.string(),
  location_id: z.string().nullable(),
  movement_id: z.string().nullable(),
  note: z.string().nullable(),
  purchase_order_id: z.string(),
  purchase_order_line_id: z.string(),
  quantity: z.number(),
  received_at: z.string(),
  received_by: z.string().nullable(),
  unit_cost_cents: z.number(),
  variant_id: z.string().nullable(),
}).passthrough();

/** public.purchase_orders */
export const PurchaseOrdersSchema = z.object({
  created_at: z.string(),
  created_by: z.string().nullable(),
  currency: z.string(),
  expected_on: z.string().nullable(),
  id: z.string(),
  location_id: z.string().nullable(),
  lot_allocation: z.string().nullable(),
  lot_cost_cents: z.number().nullable(),
  note: z.string().nullable(),
  ordered_on: z.string().nullable(),
  po_number: z.string().nullable(),
  status: z.string(),
  supplier_id: z.string().nullable(),
  supplier_name: z.string().nullable(),
  total_cents: z.number(),
  updated_at: z.string(),
}).passthrough();

/** public.reconciliation_runs */
export const ReconciliationRunsSchema = z.object({
  account_key: z.string().nullable(),
  cash_gap_members: z.number().nullable(),
  charges_covered: z.number().nullable(),
  charges_matched: z.number().nullable(),
  charges_total: z.number().nullable(),
  counts: z.unknown(),
  detail: z.unknown().nullable(),
  duplicate_pis: z.unknown().nullable(),
  excluded: z.unknown(),
  findings: z.unknown(),
  gap_cents: z.number(),
  gap_count: z.number(),
  id: z.string(),
  kind: z.string(),
  new_unresolved: z.unknown().nullable(),
  ok: z.boolean(),
  period_end: z.string().nullable(),
  period_start: z.string().nullable(),
  ran_at: z.string(),
  reason: z.string().nullable(),
  status: z.string().nullable(),
}).passthrough();

/** public.role_notification_settings */
export const RoleNotificationSettingsSchema = z.object({
  created_at: z.string().nullable(),
  enabled: z.boolean(),
  id: z.string(),
  notification_key: z.string(),
  role_id: z.string().nullable(),
}).passthrough();

/** public.role_permissions */
export const RolePermissionsSchema = z.object({
  permission_id: z.string(),
  role_id: z.string(),
  tenant_id: z.string().nullable(),
}).passthrough();

/** public.roles */
export const RolesSchema = z.object({
  description: z.string().nullable(),
  id: z.string(),
  is_elevated: z.boolean(),
  is_staff: z.boolean(),
  is_system: z.boolean(),
  name: z.string(),
  tenant_id: z.string().nullable(),
}).passthrough();

/** public.saved_segments */
export const SavedSegmentsSchema = z.object({
  audience_spec: z.unknown(),
  audience_type: z.string(),
  created_at: z.string(),
  created_by: z.string().nullable(),
  description: z.string().nullable(),
  id: z.string(),
  is_archived: z.boolean(),
  name: z.string(),
  tenant_id: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.scheduled_payments */
export const ScheduledPaymentsSchema = z.object({
  amount: z.number(),
  created_at: z.string(),
  description: z.string().nullable(),
  error_code: z.string().nullable(),
  error_message: z.string().nullable(),
  id: z.string(),
  invoice_id: z.string().nullable(),
  last_retry_date: z.string().nullable(),
  max_retries: z.number(),
  membership_id: z.string(),
  metadata: z.unknown().nullable(),
  next_retry_date: z.string().nullable(),
  parent_scheduled_payment_id: z.string().nullable(),
  payment_intent_id: z.string().nullable(),
  payment_method: z.string().nullable(),
  processed_at: z.string().nullable(),
  processed_by: z.unknown().nullable(),
  retry_count: z.number(),
  scheduled_date: z.string(),
  status: z.string(),
  tenant_id: z.string(),
  type: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.settings */
export const SettingsSchema = z.object({
  about_us_full: z.string().nullable(),
  ach_fee: z.number(),
  ad_spend_by_platform: z.unknown().nullable(),
  age_check_mode: z.string(),
  ai_chat_anon_daily_message_cap: z.number(),
  ai_chat_anon_email_required: z.boolean(),
  ai_chat_anon_max_email_attempts: z.number(),
  ai_chat_anon_max_messages_per_session: z.number(),
  ai_chat_anon_max_sessions_per_window: z.number(),
  ai_chat_anon_session_window_days: z.number(),
  ai_chat_anonymous_enabled: z.boolean(),
  ai_chat_disclosure_text: z.string().nullable(),
  ai_chat_member_max_messages_per_day: z.number(),
  allow_makeups: z.boolean(),
  allow_open_hours_slots: z.boolean(),
  allow_other_gender: z.boolean().nullable(),
  allow_post_comments: z.boolean(),
  allow_post_reactions: z.boolean(),
  allow_staff_magic_link: z.boolean(),
  analytics_dashboard_embed_url: z.string().nullable(),
  annual_fee_billing_model: z.string(),
  annual_fee_enabled: z.boolean(),
  annual_fee_fixed_month: z.number().nullable(),
  annual_waiver_requests_enabled: z.boolean(),
  applied_late_fees: z.boolean(),
  apply_payment_processing_fee_to_invoice: z.boolean(),
  athlete_monitoring_enabled: z.boolean().nullable(),
  athlete_required_fields: z.unknown(),
  athlete_signin_enabled: z.boolean(),
  attendance_mode: z.string(),
  attire_fields: z.unknown().nullable(),
  attire_team_only: z.boolean().nullable(),
  auth_health_alerts_enabled: z.boolean().nullable(),
  auth_health_min_failures: z.number().nullable(),
  auth_health_min_rate: z.number().nullable(),
  auth_health_systemic: z.number().nullable(),
  auto_invoice_day: z.string().nullable(),
  auto_invoice_drafts_only: z.boolean(),
  auto_invoice_enabled: z.boolean(),
  auto_invoice_frequency: z.string().nullable(),
  auto_invoice_time: z.string().nullable(),
  auto_prorate_on_self_enroll: z.boolean().nullable(),
  automated_dunning_enabled: z.boolean(),
  autopay_charge_mode: z.string(),
  autopay_failure_email_enabled: z.boolean(),
  autopay_grace_period_days: z.number(),
  autopay_grace_period_enabled: z.boolean(),
  autopay_minimum_charge: z.number(),
  barcode_scan_enabled: z.boolean(),
  billing_report_assignee_id: z.string().nullable(),
  billing_run_report_enabled: z.boolean(),
  birthday_greeting_enabled: z.boolean(),
  birthday_party_prompt_days_in_advance: z.number(),
  birthday_party_prompt_enabled: z.boolean(),
  blog_enabled: z.boolean().nullable(),
  books_catch_up_enabled: z.boolean(),
  books_posting_enabled: z.boolean(),
  books_posting_from: z.string().nullable(),
  brand_voice: z.string().nullable(),
  business_name: z.string().nullable(),
  business_website: z.string().nullable(),
  camp_default_visibility: z.string().nullable(),
  capacity_alerts_enabled: z.boolean().nullable(),
  capacity_alerts_threshold: z.number().nullable(),
  capacity_oversell_pct: z.number(),
  card_expiration_notifications_enabled: z.boolean(),
  config_review_reminders_enabled: z.boolean(),
  confirmation_manage_account_text: z.string().nullable(),
  confirmation_schedule_text: z.string().nullable(),
  confirmation_welcome_text: z.string().nullable(),
  confirmation_what_to_expect_text: z.string().nullable(),
  contact_address: z.string().nullable(),
  contact_email: z.string().nullable(),
  contact_phone: z.string().nullable(),
  created_at: z.string().nullable(),
  credit_card_fee: z.number(),
  currency_code: z.string(),
  currency_decimal_places: z.number(),
  daily_attendance_report_enabled: z.boolean(),
  daily_financial_report_enabled: z.boolean(),
  data_health_alerts_enabled: z.boolean().nullable(),
  default_lead_assignee_id: z.string().nullable(),
  discount_codes_enabled: z.boolean(),
  dunning_final_repeat_days: z.number(),
  dunning_minimum_owed: z.number(),
  dunning_stage1_days: z.number().nullable(),
  dunning_stage2_days: z.number().nullable(),
  dunning_stage3_days: z.number().nullable(),
  email_schedules: z.boolean().nullable(),
  email_verification_daily_cap: z.number(),
  enforce_program_capacity: z.boolean().nullable(),
  event_reminders_enabled: z.boolean(),
  export_button_color: z.string().nullable(),
  facebook_link: z.string().nullable(),
  facility_booking_balance_pay_enabled: z.boolean(),
  facility_booking_enabled: z.boolean(),
  facility_booking_members_enabled: z.boolean(),
  facility_booking_public_enabled: z.boolean(),
  facility_booking_tax_rate: z.number().nullable(),
  facility_emails_cancellation_enabled: z.boolean(),
  facility_emails_confirmation_enabled: z.boolean(),
  facility_emails_reminder_enabled: z.boolean(),
  facility_no_show_refund_pct: z.number(),
  facility_public_payment_window_min: z.number(),
  facility_refund_full_tax: z.boolean(),
  facility_reschedule_fee_amount: z.number(),
  facility_reschedule_fee_enabled: z.boolean(),
  facility_reschedule_fee_hours_before: z.number(),
  facility_suppress_stripe_receipt: z.boolean(),
  fee_active_time_source: z.string().nullable(),
  fee_cadence_mode: z.string().nullable(),
  fee_cycle_months: z.number().nullable(),
  fee_on_enroll_enabled: z.boolean().nullable(),
  fee_reactivation_grace_days: z.number().nullable(),
  fee_staleness_cutoff_months: z.number().nullable(),
  feed_back_recipient: z.string().nullable(),
  feedback_high_score_message: z.string(),
  feedback_low_score_message: z.string(),
  feedback_low_score_notify_user_ids: z.unknown(),
  feedback_post_camp_days_after: z.number(),
  feedback_post_camp_enabled: z.boolean(),
  feedback_post_clinic_days_after: z.number(),
  feedback_post_clinic_enabled: z.boolean(),
  feedback_post_event_days_after: z.number(),
  feedback_post_event_enabled: z.boolean(),
  feedback_post_trial_days_after: z.number(),
  feedback_post_trial_enabled: z.boolean(),
  feedback_review_url_facebook: z.string().nullable(),
  feedback_review_url_google: z.string().nullable(),
  feedback_review_url_yelp: z.string().nullable(),
  feedback_threshold_pct: z.number(),
  font_family: z.string().nullable(),
  footer_text: z.string().nullable(),
  from_email: z.string().nullable(),
  future_invoices_enabled: z.boolean(),
  ga_tracking_id: z.string().nullable(),
  geocode_calls_today: z.number().nullable(),
  geocode_calls_today_date: z.string().nullable(),
  gp_api_key: z.string().nullable(),
  gp_commission_rate: z.number().nullable(),
  gp_enabled: z.boolean().nullable(),
  gp_last_sync_at: z.string().nullable(),
  gp_markup_percentage: z.number().nullable(),
  gp_music_enabled: z.boolean().nullable(),
  gp_section_title: z.string().nullable(),
  gp_show_branding: z.boolean().nullable(),
  gp_sync_status: z.string().nullable(),
  hero_cta_text: z.string().nullable(),
  hero_image_url: z.string().nullable(),
  hr_documents_enabled: z.boolean().nullable(),
  hr_module_enabled: z.boolean().nullable(),
  hr_onboarding_enabled: z.boolean().nullable(),
  hr_payroll_enabled: z.boolean().nullable(),
  hr_time_tracking_enabled: z.boolean().nullable(),
  id: z.string(),
  inactivity_auto_deactivate_member_when_no_active_athletes: z.boolean(),
  inactivity_automation_enabled: z.boolean(),
  inactivity_missed_for_admin_notice: z.number(),
  inactivity_missed_for_auto_deactivate: z.number(),
  inactivity_missed_for_member_email: z.number(),
  instagram_link: z.string().nullable(),
  invoice_email_to_responsible_person: z.boolean(),
  invoice_source_labels: z.unknown().nullable(),
  landing_sections: z.unknown().nullable(),
  late_fee_balance_aging_days: z.number(),
  late_fee_balance_aging_effective_date: z.string().nullable(),
  late_fee_balance_aging_grace_days: z.number(),
  late_fee_eligible_invoice_sources: z.unknown().nullable(),
  late_fee_mode: z.string(),
  late_fee_per_invoice_effective_date: z.string().nullable(),
  late_fee_per_invoice_recurrence_days: z.number(),
  lms_enabled: z.boolean().nullable(),
  local_seo_state: z.unknown().nullable(),
  locale: z.string(),
  logo_url: z.string().nullable(),
  low_stock_threshold: z.number(),
  makeup_drop_in_rate: z.number().nullable(),
  mark_absent_enabled: z.boolean(),
  max_negative_balance: z.number(),
  member_account_balance_enabled: z.boolean(),
  member_can_unenroll_athlete: z.boolean(),
  missing_attendance_notification_enabled: z.boolean().nullable(),
  missing_attendance_notification_hour: z.number().nullable(),
  monthly_billing_enabled: z.boolean(),
  monthly_billing_requires_attendance: z.boolean(),
  negative_balance_notification_frequency: z.string().nullable(),
  negative_balance_notification_template: z.string().nullable(),
  negative_balance_notifications_enabled: z.boolean(),
  notification_additional_recipients: z.unknown().nullable(),
  notification_roles: z.unknown().nullable(),
  notify_attendance_notice: z.boolean(),
  notify_member_email: z.boolean(),
  notify_member_notice: z.boolean(),
  owner_data_health_banner_enabled: z.boolean().nullable(),
  owner_data_health_digest_enabled: z.boolean().nullable(),
  owner_notification_sms_events: z.unknown(),
  owner_notification_sms_to: z.string().nullable(),
  participant_label_plural: z.string(),
  participant_label_singular: z.string(),
  pass_ach_fee_to_customer: z.boolean(),
  pass_card_fee_to_customer: z.boolean(),
  payment_deadlines_enabled: z.boolean(),
  payment_method_routing_enabled: z.boolean(),
  payment_schedule_auto_extend: z.boolean(),
  pos_enabled: z.boolean(),
  pos_receipt_footer: z.string().nullable(),
  post_comment_moderation: z.string(),
  primary_color: z.string().nullable(),
  private_session_pricing: z.unknown().nullable(),
  private_sessions_enabled: z.boolean().nullable(),
  private_sessions_kiosk_visible: z.boolean().nullable(),
  private_sessions_member_scheduling: z.boolean().nullable(),
  program_to_product_conversion: z.boolean(),
  prorate_on_staff_enroll_default: z.boolean().nullable(),
  public_programs_layout: z.string(),
  push_notifications_enabled: z.boolean(),
  registration_wizard_enabled: z.boolean(),
  reply_to_email: z.string().nullable(),
  report_roles: z.unknown().nullable(),
  reputation_digest_enabled: z.boolean(),
  reputation_digest_frequency_days: z.number(),
  reputation_digest_last_sent_at: z.string().nullable(),
  require_check_number: z.boolean().nullable(),
  require_payment_on_enroll_reactivate: z.boolean(),
  require_phone_address_on_registration: z.boolean(),
  require_zero_balance_to_reactivate: z.boolean(),
  sales_tax_percent: z.number(),
  save_button_color: z.string().nullable(),
  scheduled_athlete_cancellations_enabled: z.boolean(),
  scheduled_cancellations_enabled: z.boolean(),
  scheduled_payments_enabled: z.boolean(),
  scheduled_unenrollments_enabled: z.boolean(),
  search_console_verification: z.string().nullable(),
  secondary_color: z.string().nullable(),
  seo_default_description: z.string().nullable(),
  seo_social_image: z.string().nullable(),
  seo_title_suffix: z.string().nullable(),
  shipping_rate_table: z.unknown().nullable(),
  sku_auto_generate: z.boolean(),
  slot_capacity_block_at_max: z.boolean(),
  slot_capacity_notification_channels: z.unknown(),
  slot_capacity_notifications_enabled: z.boolean(),
  slot_capacity_notify_roles: z.unknown(),
  slot_capacity_warn_threshold_pct: z.number(),
  slot_capacity_weekly_digest_enabled: z.boolean(),
  sms_quiet_hours_enabled: z.boolean(),
  sms_quiet_hours_end: z.string(),
  sms_quiet_hours_start: z.string(),
  staff_default_home_route: z.string().nullable(),
  staff_idle_timeout_minutes: z.number().nullable(),
  staff_notice_digest_enabled: z.boolean(),
  staff_notice_digest_hour: z.number(),
  store_require_membership: z.boolean().nullable(),
  storefront_banner_url: z.string().nullable(),
  storefront_visibility: z.string().nullable(),
  stripe_reconciliation_alert_emails: z.string().nullable(),
  stripe_reconciliation_alert_enabled: z.boolean().nullable(),
  stripe_reconciliation_alert_last_run_at: z.string().nullable(),
  stripe_reconciliation_alert_lookback_days: z.number().nullable(),
  stripe_terminal_location_id: z.string().nullable(),
  task_digest_enabled: z.boolean(),
  tax_enabled: z.boolean(),
  tax_id_ein: z.string().nullable(),
  tax_status: z.string().nullable(),
  tenant_id: z.string().nullable(),
  terminal_enabled: z.boolean(),
  timezone: z.string().nullable(),
  trial_days: z.number().nullable(),
  trial_enabled: z.boolean().nullable(),
  trial_followup_enabled: z.boolean(),
  trial_requires_payment_method: z.boolean().nullable(),
  trial_terms_text: z.string().nullable(),
  updated_at: z.string().nullable(),
  vacation_default_billing_mode: z.string().nullable(),
  vacation_mode_enabled: z.boolean().nullable(),
  vacation_reminder_default_days: z.number().nullable(),
  weekly_attendance_report_enabled: z.boolean(),
  weekly_financial_report_enabled: z.boolean(),
  weekly_owner_digest_enabled: z.boolean().nullable(),
  weekly_owner_digest_last_sent_at: z.string().nullable(),
  wizard_drafts_auto_publish_enabled: z.boolean(),
  x_link: z.string().nullable(),
}).passthrough();

/** public.skill_categories */
export const SkillCategoriesSchema = z.object({
  applicable_levels: z.unknown().nullable(),
  color: z.string().nullable(),
  created_at: z.string().nullable(),
  description: z.string().nullable(),
  display_order: z.number().nullable(),
  id: z.string(),
  name: z.string(),
  status: z.string(),
  tenant_id: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.skills */
export const SkillsSchema = z.object({
  applicable_levels: z.unknown().nullable(),
  category_id: z.string(),
  created_at: z.string().nullable(),
  description: z.string().nullable(),
  display_order: z.number().nullable(),
  id: z.string(),
  max_proficiency: z.number(),
  name: z.string(),
  status: z.string(),
  tenant_id: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.staff_call_availability */
export const StaffCallAvailabilitySchema = z.object({
  app_platform: z.string().nullable(),
  app_registered_at: z.string().nullable(),
  app_unregistered_at: z.string().nullable(),
  last_call_ended_at: z.string().nullable(),
  on_call_session_id: z.string().nullable(),
  on_call_since: z.string().nullable(),
  status: z.string(),
  status_expires_at: z.string().nullable(),
  status_note: z.string().nullable(),
  tenant_id: z.string().nullable(),
  updated_at: z.string(),
  user_id: z.string(),
  web_last_seen_at: z.string().nullable(),
  web_registered: z.boolean(),
}).passthrough();

/** public.staff_notice_outbox */
export const StaffNoticeOutboxSchema = z.object({
  body: z.string().nullable(),
  created_at: z.string(),
  dedupe_key: z.string().nullable(),
  dismissed_at: z.string().nullable(),
  email_attempts: z.number(),
  email_next_attempt_at: z.string().nullable(),
  emailed_at: z.string().nullable(),
  id: z.string(),
  kind: z.string(),
  link: z.string().nullable(),
  meta: z.unknown(),
  sms_sent_at: z.string().nullable(),
  source_id: z.string().nullable(),
  source_table: z.string().nullable(),
  title: z.string(),
  to_email: z.string().nullable(),
  user_id: z.string().nullable(),
  website_id: z.string().nullable(),
}).passthrough();

/** public.stripe_reconciliation_findings */
export const StripeReconciliationFindingsSchema = z.object({
  charge_amount: z.number(),
  charge_created_at: z.string().nullable(),
  charge_description: z.string().nullable(),
  created_at: z.string(),
  customer_email: z.string().nullable(),
  customer_name: z.string().nullable(),
  discrepancy_amount: z.number(),
  finding_type: z.string(),
  first_seen_at: z.string(),
  id: z.string(),
  last_seen_at: z.string(),
  membership_id: z.string().nullable(),
  metadata: z.unknown().nullable(),
  recorded_amount: z.number(),
  resolution_note: z.string().nullable(),
  resolved_at: z.string().nullable(),
  resolved_by: z.string().nullable(),
  status: z.string(),
  stripe_charge_id: z.string(),
  stripe_payment_intent_id: z.string().nullable(),
  tenant_id: z.string().nullable(),
  updated_at: z.string(),
}).passthrough();

/** public.stripe_reconciliation_ignore_rules */
export const StripeReconciliationIgnoreRulesSchema = z.object({
  active: z.boolean(),
  created_at: z.string(),
  created_by: z.string().nullable(),
  created_from_finding_id: z.string().nullable(),
  deactivated_at: z.string().nullable(),
  deactivated_by: z.string().nullable(),
  id: z.string(),
  kind: z.string(),
  label: z.string(),
  tenant_id: z.string().nullable(),
  value: z.string(),
}).passthrough();

/** public.stripe_webhook_events */
export const StripeWebhookEventsSchema = z.object({
  claimed_at: z.string().nullable(),
  duration_ms: z.number().nullable(),
  error_message: z.string().nullable(),
  event_created_at: z.string().nullable(),
  event_type: z.string(),
  id: z.string(),
  processed_at: z.string().nullable(),
  received_at: z.string(),
  status: z.string(),
  stripe_event_id: z.string(),
  summary: z.unknown().nullable(),
}).passthrough();

/** public.system_events */
export const SystemEventsSchema = z.object({
  created_at: z.string().nullable(),
  event_name: z.string(),
  id: z.number(),
  payload: z.unknown().nullable(),
}).passthrough();

/** public.task_attachments */
export const TaskAttachmentsSchema = z.object({
  content_type: z.string().nullable(),
  created_at: z.string(),
  file_name: z.string(),
  file_size: z.number().nullable(),
  id: z.string(),
  storage_path: z.string(),
  task_id: z.string(),
  tenant_id: z.string(),
  uploaded_by: z.string().nullable(),
}).passthrough();

/** public.task_comments */
export const TaskCommentsSchema = z.object({
  author_id: z.string().nullable(),
  body: z.string(),
  created_at: z.string(),
  id: z.string(),
  kind: z.string(),
  meta: z.unknown(),
  task_id: z.string(),
  tenant_id: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.task_digest_claims */
export const TaskDigestClaimsSchema = z.object({
  claimed_at: z.string(),
  digest_day: z.string(),
  error_message: z.string().nullable(),
  id: z.string(),
  sent_at: z.string().nullable(),
  status: z.string(),
  user_id: z.string(),
}).passthrough();

/** public.teams */
export const TeamsSchema = z.object({
  coach_id: z.string().nullable(),
  color: z.string().nullable(),
  created_at: z.string().nullable(),
  description: z.string().nullable(),
  id: z.string(),
  name: z.string(),
  status: z.string().nullable(),
  tenant_id: z.string().nullable(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.tenant_config_reviews */
export const TenantConfigReviewsSchema = z.object({
  cadence_days: z.number(),
  created_at: z.string(),
  id: z.string(),
  kind: z.string(),
  last_completed_at: z.string().nullable(),
  last_started_at: z.string().nullable(),
  next_due_at: z.string(),
  snoozed_until: z.string().nullable(),
  tenant_id: z.string(),
  updated_at: z.string(),
}).passthrough();

/** public.tenant_knowledge */
export const TenantKnowledgeSchema = z.object({
  audience: z.string().nullable(),
  content: z.string(),
  content_hash: z.string().nullable(),
  content_type: z.string(),
  created_at: z.string().nullable(),
  created_by: z.string().nullable(),
  embedding: z.unknown().nullable(),
  embedding_model: z.string().nullable(),
  id: z.string(),
  is_active: z.boolean().nullable(),
  metadata: z.unknown().nullable(),
  source: z.string().nullable(),
  tags: z.unknown().nullable(),
  tenant_id: z.string(),
  title: z.string(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.tenants */
export const TenantsSchema = z.object({
  created_at: z.string().nullable(),
  domain: z.string(),
  id: z.string(),
  name: z.string(),
  schema_name: z.string(),
  settings: z.unknown().nullable(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.time_entries */
export const TimeEntriesSchema = z.object({
  approved_at: z.string().nullable(),
  approved_by: z.string().nullable(),
  clock_in: z.string().nullable(),
  clock_out: z.string().nullable(),
  created_at: z.string().nullable(),
  employee_profile_id: z.string(),
  entry_type: z.string().nullable(),
  hours_worked: z.number().nullable(),
  id: z.string(),
  notes: z.string().nullable(),
  status: z.string().nullable(),
  tenant_id: z.string(),
  timesheet_id: z.string().nullable(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.timesheets */
export const TimesheetsSchema = z.object({
  approved_at: z.string().nullable(),
  approved_by: z.string().nullable(),
  created_at: z.string().nullable(),
  employee_profile_id: z.string(),
  id: z.string(),
  notes: z.string().nullable(),
  overtime_hours: z.number().nullable(),
  period_end: z.string(),
  period_start: z.string(),
  status: z.string().nullable(),
  submitted_at: z.string().nullable(),
  tenant_id: z.string(),
  total_hours: z.number().nullable(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.unified_communications */
export const UnifiedCommunicationsSchema = z.object({
  ai_confidence_score: z.number().nullable(),
  ai_conversation_id: z.string().nullable(),
  ai_handled: z.boolean().nullable(),
  attachments: z.unknown().nullable(),
  body: z.string().nullable(),
  body_html: z.string().nullable(),
  call_duration_seconds: z.number().nullable(),
  call_recording_url: z.string().nullable(),
  call_status: z.string().nullable(),
  call_transcription: z.string().nullable(),
  channel: z.string(),
  created_at: z.string().nullable(),
  delivered_at: z.string().nullable(),
  delivery_error_code: z.string().nullable(),
  delivery_error_message: z.string().nullable(),
  delivery_finalized_at: z.string().nullable(),
  delivery_status: z.string().nullable(),
  direction: z.string(),
  email_bcc: z.unknown().nullable(),
  email_cc: z.unknown().nullable(),
  email_from: z.string().nullable(),
  email_to: z.unknown().nullable(),
  external_id: z.string().nullable(),
  external_thread_id: z.string().nullable(),
  handled_by: z.string().nullable(),
  id: z.string(),
  is_auto_reply: z.boolean().nullable(),
  lead_id: z.string().nullable(),
  membership_id: z.string().nullable(),
  metadata: z.unknown().nullable(),
  read_at: z.string().nullable(),
  responded_at: z.string().nullable(),
  response_time_seconds: z.number().nullable(),
  sent_at: z.string().nullable(),
  sms_from: z.string().nullable(),
  sms_segments: z.number().nullable(),
  sms_to: z.string().nullable(),
  status: z.string().nullable(),
  subject: z.string().nullable(),
  tenant_id: z.string(),
  thread_id: z.string().nullable(),
  updated_at: z.string().nullable(),
}).passthrough();

/** public.unsubscribed_emails */
export const UnsubscribedEmailsSchema = z.object({
  email: z.string(),
  id: z.string(),
  reason: z.string().nullable(),
  source_id: z.string().nullable(),
  source_type: z.string().nullable(),
  tenant_id: z.string(),
  unsubscribed_at: z.string().nullable(),
}).passthrough();

/** public.user_dashboard_layout */
export const UserDashboardLayoutSchema = z.object({
  config: z.unknown(),
  created_at: z.string(),
  id: z.string(),
  order: z.number(),
  updated_at: z.string(),
  user_id: z.string(),
  widget_id: z.string(),
}).passthrough();

/** public.users */
export const UsersSchema = z.object({
  address: z.string().nullable(),
  alternate_email: z.string().nullable(),
  alternate_email_2: z.string().nullable(),
  alternate_phone: z.string().nullable(),
  auth_id: z.string().nullable(),
  avatar_url: z.string().nullable(),
  balance: z.number(),
  billing_notes: z.string().nullable(),
  call_transactional_opt_in_at: z.string().nullable(),
  call_transactional_opt_out_at: z.string().nullable(),
  carrier: z.string().nullable(),
  city: z.string().nullable(),
  comm_opt_in_source: z.string().nullable(),
  comm_opt_in_version: z.string().nullable(),
  created_at: z.string(),
  dismissed_tip_ids: z.unknown().nullable(),
  email: z.string(),
  email_marketing_opt_in_at: z.string().nullable(),
  email_marketing_opt_out_at: z.string().nullable(),
  email_transactional_opt_in_at: z.string().nullable(),
  email_transactional_opt_out_at: z.string().nullable(),
  first_name: z.string(),
  id: z.string(),
  idle_timeout_minutes: z.number().nullable(),
  last_name: z.string(),
  last_tip_shown_at: z.string().nullable(),
  mobile_sms: z.string().nullable(),
  phone: z.string().nullable(),
  preferences: z.unknown(),
  preferred_language: z.string(),
  push_opt_in_at: z.string().nullable(),
  push_opt_out_at: z.string().nullable(),
  referral: z.string().nullable(),
  role: z.string(),
  role_id: z.string().nullable(),
  sessions_valid_after: z.string().nullable(),
  sms_marketing_opt_in_at: z.string().nullable(),
  sms_marketing_opt_out_at: z.string().nullable(),
  sms_transactional_opt_in_at: z.string().nullable(),
  sms_transactional_opt_out_at: z.string().nullable(),
  staff_home_route: z.string().nullable(),
  state: z.string().nullable(),
  status: z.string().nullable(),
  stripe_customer_id: z.string().nullable(),
  support_phone: z.string().nullable(),
  tenant_id: z.string().nullable(),
  tips_disabled: z.boolean().nullable(),
  updated_at: z.string().nullable(),
  zip: z.string().nullable(),
}).passthrough();

/** public.waiver_requests */
export const WaiverRequestsSchema = z.object({
  athlete_ids: z.unknown().nullable(),
  batch_id: z.string(),
  batch_label: z.string().nullable(),
  created_at: z.string(),
  expires_at: z.string().nullable(),
  id: z.string(),
  last_send_error: z.string().nullable(),
  last_sent_at: z.string().nullable(),
  membership_id: z.string(),
  period: z.string().nullable(),
  send_count: z.number(),
  sent_at: z.string().nullable(),
  sent_by_user_id: z.string().nullable(),
  sent_to_email: z.string().nullable(),
  signed_at: z.string().nullable(),
  source: z.string(),
  status: z.string(),
  submission_id: z.string().nullable(),
  tenant_id: z.string().nullable(),
  token_hash: z.string().nullable(),
  updated_at: z.string(),
  waiver_id: z.string(),
  waiver_version: z.number(),
}).passthrough();

/** public.waiver_submissions */
export const WaiverSubmissionsSchema = z.object({
  athlete_ids: z.unknown(),
  consent_text: z.string().nullable(),
  content_hash_alg: z.string().nullable(),
  content_sha256: z.string().nullable(),
  declined: z.boolean(),
  form_data: z.unknown(),
  id: z.string(),
  ip_address: z.string().nullable(),
  membership_id: z.string(),
  signed_by_email: z.string().nullable(),
  signed_by_name: z.string().nullable(),
  signed_by_user_id: z.string().nullable(),
  signed_via: z.string().nullable(),
  submitted_at: z.string().nullable(),
  tenant_id: z.string(),
  waiver_id: z.string(),
  waiver_request_id: z.string().nullable(),
  waiver_version: z.number(),
  waiver_version_id: z.string().nullable(),
}).passthrough();

/** public.waiver_versions */
export const WaiverVersionsSchema = z.object({
  blocks: z.unknown(),
  content_sha256: z.string(),
  created_at: z.string(),
  description: z.string().nullable(),
  id: z.string(),
  name: z.string().nullable(),
  tenant_id: z.string().nullable(),
  version: z.number(),
  waiver_id: z.string(),
}).passthrough();

/** public.waivers */
export const WaiversSchema = z.object({
  allow_decline: z.boolean(),
  blocks: z.unknown(),
  counts_on_rosters: z.boolean(),
  created_at: z.string().nullable(),
  deleted_at: z.string().nullable(),
  description: z.string().nullable(),
  id: z.string(),
  is_photo_release: z.boolean(),
  name: z.string(),
  required_since: z.string().nullable(),
  show_on_member_portal: z.boolean().nullable(),
  show_on_member_registration: z.boolean().nullable(),
  tenant_id: z.string(),
  updated_at: z.string().nullable(),
  version: z.number(),
}).passthrough();
